import React, { useEffect, useRef, useState } from 'react'
import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Divider,
  Checkbox,
  Radio,
  Switch,
  Modal,
  Input,
  Select,
  message,
} from 'antd'
import { connect, useDispatch, useSelector } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
  SaveIco,
  SaveBlueIco,
  RefreshIco,
  SearchIco,
  MinusSmallIco,
  PlusSmallIco,
  DraggableMoveUpDownIco,
  InputSearchIco,
  ModalCloseIco,
  DocumentsIco,
  EroorIco,
} from '../../../../../modules/CustomIcons'
import { setDgkData } from "../../../../store/actions/DGK";
import './index.scss'
import '../../transfer.scss'
import { OWNACCOUNT } from 'constants/constants'
import {
  Account,
  getAccounts,
  getSavedDocuments,
} from '../../../../services/account'
import { SelectOptions } from '../../../../services/form'
import { getCurrentCompany, getUserData } from '../../../../services/user'
import {
  checkAmountForRequest,
  fillCurrentForm,
  fillCurrentFormTemplate,
  financial,
  resetForm,
} from '../../../../services/helper'
import AmountField from 'components/AmountField'
import NextModal from 'components/NextModal'
import {
  getBicCodes,
  BicCodes,
  BankCodes,
  getBankCodes,
  getBicCodesByFilter,
  getBicCodesByCountryName,
} from '../../../../services/moneytransfer'
import { getSwiftDocumentNumber } from '../../../../services/Accounts/DocumentNumber'
import { getcrosscurrency, newMoneyTransferSwift } from '../../../../services/Transfers/Swift'
import TemplatePopup from 'components/TemplatePopup'
import { getCustomerCommission } from '../../../../services/Customers/Commission'
import SaveAsTemplate from 'components/SaveAsTemplate'
import { useLocation } from 'react-router-dom'
import { newMoneyTransferAzips } from '../../../../services/Transfers/Azips'
import FullScreenLoading from 'components/FullScreenLoading'
import { setIbanNumber } from '../../../../store/actions/accountStatement'
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import DocumentsModal from 'components/DocumentsModal'
import moment from 'moment'

import FormItem from 'antd/es/form/FormItem'
import {deleteFileById} from "../../../../services/Transfers/Files";
import DgkModal from 'components/DGKmodals/DgkModal'
import { GetCustomerCountries, GetInfByGBNO, GetInfByPinCode } from '../../../../services/Transfers/dgk'

const CurrencyTransactions: React.FC<any> = ({ ownProps, ibanNumber }) => {
  interface DataType {
    key: string
    docId: React.Key
    docName: string
    docNumAbsent: boolean
    docNum: string
    docDate: string
    docNote: string
    isUsed: Boolean
    docNameLabel: string
    docNameId: number
  }
  const items = [
    {
      label: 'Contract',
      value: 'Contract',
      code: 'CNT',
      key: 1,
    },
    {
      label: 'Invoice',
      value: 'Invoice',
      code: 'INV',
      key: 2,
    },
    {
      label: 'Purchase Order',
      value: 'Purchase Order',
      code: 'PO',
      key: 3,
    },
    {
      label: 'Debit Note',
      value: 'Debit Note',
      code: 'DN',
      key: 4,
    },
    {
      label: 'GB',
      value: 'GB',
      code: 'GB',
      key: 5,
    },
    {
      label: 'Letter',
      value: 'Letter',
      code: 'LETTER',
      key: 6,
    },
    {
      label: "Shareholders' resolution",
      value: "Shareholders' resolution",
      code: 'SHAREHOLD.RESOL',
      key: 7,
    },
    {
      label: "Court's decision",
      value: "Court's decision",
      code: 'COURT.DECIS',
      key: 8,
    },
    {
      label: 'Incoming SWIFT',
      value: 'Incoming SWIFT',
      code: 'INC.SWIFT',
      key: 9,
    },
  ]
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const options = [
    {
      label: t('transfers.swiftCode'),
      value: 1,
      placeholder: t('newTransfer.atLeast3Char'),
      title: t('transfers.swiftCode'),
      required: {
        titleRequired: true,
        nameRequired: false,
        nameDisabled: true,
        adrDisabled: true,
        nameShowCount: false,
        nameMaxLength: false,
        adrShowCount: false,
        adrMaxLength: false,
        titleShowCount: false,
        titleMaxLength: false,
      },
      autoComplete: true,
      currency: 'GBP',
    },
    {
      label: t('newTransfer.sortCode'),
      value: 2,
      placeholder: '',
      title: t('newTransfer.sortCode'),
      required: {
        titleRequired: true,
        nameRequired: true,
        nameDisabled: false,
        adrDisabled: false,
        nameShowCount: 70,
        nameMaxLength: 70,
        adrShowCount: 70,
        adrMaxLength: 70,
        titleShowCount: false,
        titleMaxLength: 6,
      },
      autoComplete: false,
      currency: 'GBP',
    },
    {
      label: t('newTransfer.ABARouting'),
      value: 3,
      placeholder: '',
      title: t('newTransfer.ABARouting'),
      required: {
        titleRequired: true,
        nameRequired: true,
        nameDisabled: false,
        adrDisabled: false,
        nameShowCount: 70,
        nameMaxLength: 70,
        adrShowCount: 70,
        adrMaxLength: 70,
        titleShowCount: false,
        titleMaxLength: 10,
      },
      autoComplete: false,
      currency: 'USD',
    },
    {
      label: t('home.other'),
      value: 4,
      placeholder: '',
      title: t('newTransfer.accountCorrespondentBank'),
      required: {
        titleRequired: false,
        nameRequired: true,
        nameDisabled: false,
        adrDisabled: false,
        nameShowCount: true,
        nameMaxLength: 70,
        adrShowCount: true,
        adrMaxLength: 70,
        titleShowCount: true,
        titleMaxLength: 35,
      },
      autoComplete: false,
      currency: 'EUR',
    },
  ]
  const dataDocumentModal: DataType[] = [
    {
      key: '1',
      docId: '1',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
      docNameLabel: '',
      docNameId: 0,
    },
    {
      key: '2',
      docId: '2',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
    {
      key: '3',
      docId: '3',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
    {
      key: '4',
      docId: '4',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
    {
      key: '5',
      docId: '5',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
    {
      key: '6',
      docId: '6',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
    {
      key: '7',
      docId: '7',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
    {
      key: '8',
      docId: '8',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
    {
      key: '9',
      docId: '9',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
    {
      key: '10',
      docId: '10',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      docNameLabel: '',
      isUsed: false,
      docNameId: 0,
    },
  ]
  const modalDataInitial = {
    modalTitle: t('home.foreignCurrencyTransfer'),
    groups: [],
    pdfFiles: [],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
    rubNote:
      '<b style="text-align: center">Müştərinin nəzərinə! / To the attention of customer!</b>' +
      '<br>' +
      'Ödəniş tapşırığında köçürüləcək vəsaitə münasibətdə, beynəlxalq sanksiya nəticəsində tətbiq oluna biləcək məhdudiyyət, vəsaitin dondurulması/əməliyyatın icra olunmaması ehtimalından xəbərdaram. ' +
      'Müxbir bankın sorğusu əsasında beynəlxalq ödənişlər üzrə Bank tərəfindən fərdi məlumatlarımın ötürülməsinə və ödəniş tapşırığı ölkə qanunvericiliyi, bankdaxili qaydalara əsasən yoxlamalardan keçdikdən sonra ümumən Banka daxil olduqdan sonrakı 3 iş günü ərzində icra olunmasına razılığımı bildirirəm. \n' +
      '<br>' +
      'I am aware of the possibility of limiting, freezing/non-execution of a transaction that may be applied as a result of international sanctions in relation to funds under a payment order. ' +
      'I agree to the transfer of my personal data by the Bank to payments based on the request of the correspondent bank and I agree that the payment order will be executed within 3 business days after it is received by the Bank in general, passing the checks in accordance with the country\'s legislation and the Bank\'s internal procedures. ' +
      'This consent confirms that I will not claim against the Bank in future.',
  }

  const formFieldsInitial = {
    BENEFBANKCODE: '',
    BENEFBANKNAME: '',
    BENEFBANKADDR: '',
  }
  const conditions = ["YGB", "AKT", "Avans"];
  const [visible, setVisible] = useState(false)
  const [optionValue, setOptionValue] = useState(1)
  const [selectedOptionRow, setSelectedOptionRow] = useState(
    options.find((row) => row.value == optionValue)
  )
  
  const [paymentConditionValue, setPaymentConditionValue] = useState<string>();
  const [showHideIntermediaryBank, setShowHideIntermediaryBank] =
    useState(false)
  const [swiftModalVisible, setSwiftModalVisible] = useState(false)
  const [codeModalVisible, setCodeModalVisible] = useState(false)
  const [allAccounts, setAllAccounts] = useState<Account[]>()
  const [fromSelectOptions, setFromSelectOptions] = useState<SelectOptions[]>();
  const [fromBranch, setFromBranch] = useState<Account>()
  const [documentsModalVisible, setDocumentsModalVisible] = useState(false)
  const [toBranch, setToBranch] = useState<BicCodes>()
  const [toBranchIntermed, setToBranchIntermed] = useState<BicCodes>()
  const [nextModalVisible, setNextModalVisible] = useState(false)
  const [templatePopupVisible, setTemplatePopupVisible] = useState(false)
  const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] =
    useState<boolean>(false)
  const [bicCodes, setBicCodes] = useState<BicCodes>()
  const [modalData, setModalData] = useState(modalDataInitial)
  const [documentNumber, setDocumentNumber] = useState<string>('')
  const [formFields, setFormFields] = useState(formFieldsInitial)
  const [commissionLoading, setCommissionLoading] = useState(false)
  const [commissionAmount, setCommissionAmount] = useState('')
  const [refreshDocuments, setRefreshDocuments] = useState(false)
  const [bankCodes, setBankCodes] = useState<BankCodes>()
  const [allBankCodes, setAllBankCodes] = useState<BankCodes>()
  const [retryRequest, setRetryRequest] = useState(null)
  const [loadingAccount, setLoadingAccount] = useState(false)
  const [loadingData, setLoadingData] = useState(false)
  const [ibankRef, setIbankRef] = useState<string>('')
  const [pdfCount, setPdfCount] = useState(0)
  const [bankCodeSet, setBankCodeSet] = useState(false)
  const [fileList, setFileList] = useState<any[]>([])
  const [tableData, setTableData] = useState<any[]>([])
  const [documentsModalData, setModalDataDocuments] =
    useState<any[]>(dataDocumentModal)
  const [editOrRepeat, setEdit] = useState(false)
  const [documentsCount, setDocumentsCount] = useState(0)
  const [savedDocuments, setSaveDocuments] = useState('')
  const cancelPMTDETRef = useRef<string | null>(null)
  const [createData, setcreateData] = useState<any[]>([])
  const [infoData, setInfoData] = useState<any>({});
  const [openCrossMessage, setOpenCrossMessage] = useState(false);
  const [documentsData, setDocumentsData] = useState<any[]>([])
  const [form] = Form.useForm()
  const location = useLocation()
  const [activeCondition,setActiveCondition] = useState<string>();
  const [openDgkModal,setOpenDgkModal] = useState<boolean>(false);
  const [prefix, setPrefix] = useState<string>('')

  const { setIbanNumber } = useActions();
  const [dgkModalKey, setDgkModalKey] = useState(0);
  const dgkData = useSelector((state: any) => state.dgk?.data);
  const formatDate = (value: any, output: "dot" | "dash" = "dot") => {
  if (!value) return null;

  if (typeof value === "string") {
    if (value.includes("-")) {
      const [y, m, d] = value.split("-");
      if (y && m && d) {
        return output === "dot" ? `${d}.${m}.${y}` : `${y}-${m}-${d}`;
      }
    }

    if (value.includes(".")) {
      const [d, m, y] = value.split(".");
      if (d && m && y) {
        return output === "dash" ? `${y}-${m}-${d}` : `${d}.${m}.${y}`;
      }
    }

    return value;
  }

  if (value?._isAMomentObject && typeof value.format === "function") {
    return output === "dot"
      ? value.format("DD.MM.YYYY")
      : value.format("YYYY-MM-DD");
  }

  if (typeof value?.format === "function") {
    return output === "dot"
      ? value.format("DD.MM.YYYY")
      : value.format("YYYY-MM-DD");
  }

  return null;
};
const mapRepeatYgbToDgkState = (data: any) => {
  const ygbList = data?.ygb || [];
  if (!ygbList.length) return null;

  return {
    type: "YGB",
    iban: data?.CUSTACC ?? null,
    accountCurrency: data?.ccyType ?? fromBranch?.CCY_NAME ?? null,
    pages: ygbList.map((row: any) => ({
      key: row?.gbNumber ?? "",
      gbNo: row?.gbNumber ?? "",
      summary: {
        name: row?.customerFullname ?? null,
        taxId: row?.taxNumber ?? null,
        receiverCountry: row?.beneficiaryCountry ?? null,
        invoiceCost: row?.ygbInvoiceCost ?? null,
        operationAmount: row?.ygbOperationAmount ?? null,
        egbSum: row?.ygbRemainderAmount ?? null,
        invoiceCurrency: row?.ygbRemainderCcy ?? null,
        deliveryCondition: row?.pmtCondition ?? null,
        bargainingFeature: row?.ygbDeclareType ?? null,
        impDocDate: row?.ygbImpDocDate ?? null,
        impDocCost: row?.ygbDocCost ?? null,
        declarationTypeKey: row?.ygbDeclareTypeKey ?? null,
        senderOrExporter: row?.ygbSender ?? null,
        goodOfServiceInfo: row?.goodServiceInfo ?? null,
        note: row?.note ?? null,
        bankUserNumber: row?.bankUserNumber ?? null,
        pincode: row?.ygbPincode ?? row?.pincode ?? row?.pinCode ?? null,
      },
      form: {
        gbNo: row?.gbNumber ?? "",
        name: row?.customerFullname ?? "",
        receiverCountry: row?.beneficiaryCountry ?? "",
        invoiceCost: row?.ygbInvoiceCost ?? "",
        operationAmount: row?.ygbOperationAmount ?? "",
        egbSum: row?.ygbRemainderAmount ?? "",
        contractNo: row?.contractNumber ?? "",
        contractDate: formatDate(row?.ygbDate, "dash"),
        receiverCountryId: row?.countryCode != null ? String(row.countryCode) : undefined,
        receiverName: row?.beneficiaryName ?? "",
        transferredAmount: row?.ygbAmount ?? "",
        currencyType: row?.ccy ?? "",
        exchange: "",
      },
      serverData: {
        gbNo: row?.gbNumber ?? "",
        name: row?.customerFullname ?? "",
        taxId: row?.taxNumber ?? null,
        receiverCountry: row?.beneficiaryCountry ?? "",
        invoiceCost: row?.ygbInvoiceCost ?? "",
        operationAmount: row?.ygbOperationAmount ?? "",
        egbSum: row?.ygbRemainderAmount ?? "",
        invoiceCurrency: row?.ygbRemainderCcy ?? "",
        deliveryCondition: row?.pmtCondition ?? null,
        bargainingFeature: row?.ygbDeclareType ?? null,
        impDocDate: row?.ygbImpDocDate ?? null,
        impDocCost: row?.ygbDocCost ?? null,
        declarationTypeKey: row?.ygbDeclareTypeKey ?? null,
        senderOrExporter: row?.ygbSender ?? null,
        goodOfServiceInfo: row?.goodServiceInfo ?? null,
        note: row?.note ?? null,
        bankUserNumber: row?.bankUserNumber ?? null,
        contracts: row?.contractNumber
          ? [
              {
                no: row.contractNumber,
                date: formatDate(row?.ygbDate, "dash"),
              },
            ]
          : [],
        details: [],
        filePath: null,
      },
      docNoOptions: row?.contractNumber
        ? [
            {
              label: row.contractNumber,
              value: row.contractNumber,
            },
          ]
        : [],
    })),
  };
};
const formatDateForInput = (value: any) => {
  if (!value) return null;

  if (typeof value === "string") {
    if (value.includes(".")) {
      const [d, m, y] = value.split(".");
      if (d && m && y) return `${y}-${m}-${d}`;
    }
    if (value.includes("-")) return value;
  }

  return value;
};

const mapRepeatAdvanceToDgkState = (data: any) => {
  const advanceList = data?.advance || [];
  if (!advanceList.length) return null;

  const pinCode = advanceList[0]?.pin ?? null;
  const taxId = advanceList[0]?.taxNumber ?? null;
  const name = advanceList[0]?.customerFullName ?? null;

  const contracts = advanceList.map((row: any, idx: number) => ({
    id: `advance-${idx}`,
    contractNo: row?.advanceInvoiceNumber ?? "",
    contractDate: row?.advanceDate ?? "",
    accountNo: row?.accountNumber ?? "",
    countryCode: row?.country ?? undefined,
    bank: row?.beneficiaryName ?? "",
    details: row?.note
      ? [
          {
            id: `advance-detail-${idx}`,
            note: row.note,
            paymentAmount: row?.advanceAmount ?? "",
            paymentCurrency: row?.ccy ?? "",
            accountNo: row?.accountNumber ?? "",
            country: row?.country ?? "",
            bank: row?.beneficiaryName ?? "",
          },
        ]
      : [],
  }));

  const form: Record<string, any> = {};

  advanceList.forEach((row: any, idx: number) => {
    form[`contNo-${idx}`] = row?.advanceInvoiceNumber ?? "";
    form[`date-${idx}`] = formatDateForInput(row?.advanceDate);
    form[`accountNo-${idx}`] = row?.accountNumber ?? "";
    form[`avansReceiverCountryId-${idx}`] = row?.country != null ? String(row.country) : undefined;
    form[`avansReceiver-${idx}`] = row?.beneficiaryName ?? "";
    form[`avansTransferredAmount-${idx}`] = row?.advanceAmount ?? "";
    form[`avansCurrencyType-${idx}`] = row?.ccy ?? "";
    form[`avansExchange-${idx}`] = "";
  });

  return {
    type: "Avans",
    iban: data?.CUSTACC ?? null,
    pinCode,
    summary: {
      pinCode,
      taxId,
      name,
    },
    contracts,
    details: [],
    gbList: [],
    form,
  };
};
const mapRepeatActToDgkState = (data: any) => {
  const actList = data?.act || [];
  if (!actList.length) return null;

  return {
    type: "AKT",
    iban: data?.CUSTACC ?? null,
    taxId: getCurrentCompany()?.organizationCode ,
    pages: actList.map((row: any, idx: number) => ({
      key: `akt-${idx}`,
      form: {
        actDocDate: formatDateForInput(row?.actDocDate),
        noActDocNumber: String(row?.noActDocNumber) === "true",
        actDocNumber: String(row?.noActDocNumber) === "true" ? undefined : row?.actDocNumber ?? "",
        actDocCost: row?.actDocCost ?? "",
        actTransCost: row?.actTransCost ?? "",
        currencyType: row?.ccyCode ?? "",
        actExchange: "",
        actSender: row?.actSender ?? "",
        actServiceProvider: String(row?.actServiceProvider) === "true",
        actServiceProviderName:
          String(row?.actServiceProvider) === "true" ? row?.actServiceProviderName ?? "" : "",
        countryId: row?.country != null ? String(row.country) : undefined,
        goodServiceInfo: row?.goodServiceInfo ?? "",
        note: row?.note ?? "",
      },
      summary: {
        actDocDate: row?.actDocDate ?? null,
        actDocNumber: String(row?.noActDocNumber) === "true" ? null : row?.actDocNumber ?? null,
        actTransCost: row?.actTransCost ?? null,
        currencyType: row?.ccyCode ?? null,
      },
    })),
  };
};
const buildDgkPayload = () => {
  if (!dgkData?.type) {
    return {
      advance: [],
      ygb: [],
      act: [],
    };
  }

  // ===================== AVANS =====================
  if (dgkData.type === "Avans" || dgkData.type === "AVANS") {
  const dgkForm = dgkData.form || {};
  const contracts = dgkData.contracts || [];
  const result: any[] = [];

  const indexes = Object.keys(dgkForm)
    .filter((key) => key.startsWith("avansTransferredAmount-"))
    .map((key) => Number(key.split("-")[1]))
    .filter((idx) => !Number.isNaN(idx))
    .sort((a, b) => a - b);

  indexes.forEach((i) => {
    const contractRow = contracts?.[i] || {};
    const contractNo = dgkForm[`contNo-${i}`];
    const contractDate = dgkForm[`date-${i}`];
    const countryId = dgkForm[`avansReceiverCountryId-${i}`];
    const beneficiaryName = dgkForm[`avansReceiver-${i}`];
    const advanceAmount = dgkForm[`avansTransferredAmount-${i}`];
    const ccy = dgkForm[`avansCurrencyType-${i}`];

    if (!advanceAmount || !ccy || !beneficiaryName || !countryId) return;

    result.push({
      pin: dgkData?.pinCode ?? null,
      taxNumber: dgkData?.summary?.taxId ?? null,
      customerFullName: dgkData?.summary?.name ?? null,
      advanceInvoiceNumber: contractNo ?? contractRow?.contractNo ?? null,
      advanceDate: formatDate(contractDate ?? contractRow?.contractDate, "dot"),
      accountNumber: form.getFieldValue('CUSTACC') || null,
      bankTaxNumber: "9900001901",
      bankUserNumber: "505668",
      country: countryId ?? null,
      beneficiaryName: beneficiaryName ?? null,
      advanceAmount: advanceAmount ?? null,
      ccy: ccy ?? fromBranch?.CCY_NAME ?? null,
      note: "BANK RESPUBLİKA AÇIQ SƏHMDAR CƏMİYYƏTİ 505668 MÜŞTƏRİ XİDMƏTİ DEPARTAMENTİ",
      transactionDate: moment().format("DD.MM.YYYY"),
      PayAcceptance: false,
      PaymentTypeId: 2,
      // paymentDurationCondition: "3",
    });
  });

  return {
    advance: result,
    ygb: [],
    act: [],
  };
}

  // ===================== YGB =====================
  if (dgkData.type === "YGB") {
    const result = (dgkData.pages || []).map((page: any) => {
      const form = page?.form || {};
      const summary = page?.summary || {};
      const countryId = form?.receiverCountryId;
      const selectedContract = (page?.contracts || []).find((c: any) => String(c?.no) === String(form?.contractNo));

      return {
        gbNumber: page?.gbNo ?? null,
        taxNumber: summary?.taxId ?? null,
        customerFullname: summary?.name ?? null,
        beneficiaryCountry: summary?.receiverCountry ?? null,
        ygbInvoiceCost: summary?.invoiceCost ?? null,
        ygbOperationAmount: summary?.operationAmount ?? null,
        ygbRemainderAmount: summary?.egbSum ?? null,
        ygbRemainderCcy: summary?.invoiceCurrency ?? form?.currencyType ?? null,
        bankTaxNumber: "9900001901",
        bankUserNumber: summary?.bankUserNumber ?? "505668",
        ygbDocNameKey: "CUST_DECLARE",
        ygbDocName: "Yük Gömrük Bəyannaməsi",
        ygbDocNumber: page?.gbNo ?? null,
        ygbImpDocDate: formatDate(summary?.impDocDate, "dot"),
        ygbDocCost: summary?.impDocCost ?? summary?.invoiceCost ?? null,
        ygbDeclareTypeKey: summary?.declarationTypeKey ?? null,
        ygbSender: summary?.senderOrExporter ?? null,
        goodServiceInfo: summary?.goodOfServiceInfo ?? null,
        contractNumber: form?.contractNo ?? null,
        ygbDocDate: formatDate(form?.contractDate, "dot"),
        ygbPincode: selectedContract?.pincode ?? selectedContract?.pinCode ?? null,
        account: fromBranch?.IBAN ?? null,
        sendercountry: countryId ?? null,
        beneficiaryName: form?.receiverName ?? null,
        ygbAmount: form?.transferredAmount ?? null,
        ccy: form?.currencyType ?? fromBranch?.CCY_NAME ?? null,
        note: "BANK RESPUBLİKA AÇIQ SƏHMDAR CƏMİYYƏTİ 505668 MÜŞTƏRİ XİDMƏTİ DEPARTAMENTİ",
        TransactionDate: moment().format("DD.MM.YYYY"),
        countryCode: countryId ?? null,
        paymentTypeId: 1,
        // paymentDurationCondition: "1",
      };
    });

    return {
      advance: [],
      ygb: result,
      act: [],
    };
  }

  // ===================== AKT =====================
  if (dgkData.type === "AKT") {
    const result = (dgkData.pages || []).map((page: any) => {
      const form = page?.form || {};

      return {
        actDocNameKey: "SERV_ACT",
        actDocName: "Xidmətlərin qəbul edilməsini təsdiqləyən akt",
        actDocDate: formatDate(form?.actDocDate, "dot"),
        noActDocNumber: !!form?.noActDocNumber,
        actDocNumber: form?.noActDocNumber ? null : form?.actDocNumber ?? null,
        actDocCost: form?.actDocCost ?? null,
        actTransCost: form?.actTransCost ?? null,
        actSender: form?.actSender ?? null,
        actServiceProvider: !!form?.actServiceProvider,
        actServiceProviderName: form?.actServiceProvider
          ? form?.actServiceProviderName ?? null
          : null,
        country: form?.countryName ?? form?.countryId ?? null,
        goodServiceInfo: form?.goodServiceInfo ?? null,
        actNumber: form?.noActDocNumber ? "-" : form?.actDocNumber ?? null,
        ccyCode: form?.currencyType ?? fromBranch?.CCY_NAME ?? null,
        note: form?.note ?? null,
        countryCode: form?.countryId ?? null,
        transactionDate: moment().format("DD.MM.YYYY"),
        beneficiaryName: form?.beneficiaryName ?? null,
        taxId: getCurrentCompany()?.organizationCode,
        BranchCode: fromBranch?.BRANCH_NO ?? null,
        paymentType: "ocf",
        // paymentDurationCondition: "2",
      };
    });

    return {
      advance: [],
      ygb: [],
      act: result,
    };
  }

  return {
    advance: [],
    ygb: [],
    act: [],
  };
};

  const [amountCurrency,setAmountCurrency]=useState(fromBranch?.CCY_NAME);
  const [setted,setSetted]=useState(false);
  // console.log("wwe",amountCurrency);
  
 
const currencyOptions = [
  { label: "USD", value: "USD" },
  { label: "NOK", value: "NOK" },
  { label: "AED", value: "AED" },
  { label: "CAD", value: "CAD" },
  { label: "CHF", value: "CHF" },
  { label: "CZK", value: "CZK" },
  { label: "GEL", value: "GEL" },
  { label: "HUF", value: "HUF" },
  { label: "JPY", value: "JPY" },
  { label: "PLN", value: "PLN" },
  { label: "SEK", value: "SEK" },
  { label: "SGD", value: "SGD" },
  { label: "TRY", value: "TRY"},
];
  const amounttt = Form.useWatch("AMOUNT", form);
  const [currAmount,setCurrAmount] = useState(amounttt);

  const saveDocumentsModal = (dataModal: any) => {
    let tempData = JSON.parse(JSON.stringify(dataModal))
    setModalDataDocuments(tempData)
  }

  const transferAmount = checkAmountForRequest(form.getFieldValue("AMOUNT"));
  const toConvert = fromBranch?.CCY_NAME; 


useEffect(()=>{
   updateParentComponentFormData()
},[amountCurrency])

  useEffect(()=>{
    if (cancelPMTDETRef.current !== null) {
      form.setFieldValue("PMTDET", cancelPMTDETRef.current)
      cancelPMTDETRef.current = null
      return
    }
    form.setFieldValue("PMTDET",savedDocuments !== '' && documentsCount !== 0
                      ? savedDocuments?.length > 350
                        ? savedDocuments.substring(0, 350)
                        : savedDocuments
                      : '')
  },[savedDocuments])

  const updateParentComponentFormData = () => {
    if (ownProps?.getFormElements) {
      console.log(amountCurrency)
      ownProps?.getFormElements({
        form,
        pmtCurr:amountCurrency || location.state?.trnData?.pmtCurr
      })
    }
  }
  const addOrEditPage = ownProps?.addOrEditPage || false
  useEffect(() => {
    setOpenCrossMessage(false);
  }, [amounttt])
  
  const getBankcodesMethod = async () => {
    const data = await getBankCodes()

    setAllBankCodes((old_data) => data)
  }

  const updateBankCodes = async (modalVisible: boolean = true) => {
    setToBranchIntermed(undefined)

    form.resetFields(['INTERMEDBANKNAME'])
    form.resetFields(['INTERMEDBANKADDR'])

    const typed_code = form.getFieldValue('INTERMEDBANKCODE')
    const typed_bank =
      (modalVisible && form.getFieldValue('INTERMEDBANKCODE_FILTER')) || ''
    const typed_name =
      (modalVisible && form.getFieldValue('INTERMEDBANKNAME_FILTER')) || ''
    const typed_adr =
      (modalVisible &&
        form
          .getFieldValue('INTERMEDBANKADDR_FILTER')
          ?.toString()
          ?.toLowerCase()) ||
      ''
    //COUNTRY

    if (typed_code?.length >= 3) {
      const data = await getBicCodesByFilter(
        typed_code?.toString()?.toUpperCase()
      )

      let filter_codes = data
      if (typed_name !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.BANK_NAME.toString().toLowerCase().includes(typed_name)
        )
      if (typed_adr !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.COUNTRY.toString().toLowerCase().includes(typed_adr)
        )
      if (typed_bank !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.BIC_CODE.toString().toLowerCase().includes(typed_bank)
        )

      setFormFields((old_data) => ({
        ...old_data,
        INTERMEDBANKCODE: typed_code,
      }))
      setBankCodes((old_data) => filter_codes)
    }
    setCodeModalVisible(modalVisible)
  }

  const updateToBankCodeAndName = (row) => {
    setFormFields((old_data) => ({
      ...old_data,
      INTERMEDBANKCODE: row.BIC_CODE,
      INTERMEDBANKNAME: row.BANK_NAME,
      INTERMEDBANKADDR: row.COUNTRY,
    }))
    form.setFieldsValue({ INTERMEDBANKCODE: row.BIC_CODE })
    form.setFieldsValue({ INTERMEDBANKNAME: row.BANK_NAME })
    form.setFieldsValue({ INTERMEDBANKADDR: row.COUNTRY })
    updateParentComponentFormData()
    setToBranchIntermed(row)
    setCodeModalVisible(false)
  }

  const updateBicCodes = async (modalVisible: boolean = true) => {
    setToBranch(undefined)
    setFormFields((old_data) => ({
      ...old_data,
      BENEFBANKCODE: '',
      BENEFBANKNAME: '',
      BENEFBANKADDR: '',
    }))
    form.setFieldsValue({ BENEFBANKNAME: '' })
    form.setFieldsValue({ BENEFBANKADDR: '' })
    // setBankCodeSet(false)
    // @ts-ignore
    const typed_code =
      (!modalVisible && form.getFieldValue('BENEFBANKCODE')) ||
      form.getFieldValue('SWIFTCODE_FILTER') ||
      ''
    const typed_bank =
      (modalVisible && form.getFieldValue('BENEFBANKCODE_FILTER')) || ''
    const typed_name =
      (modalVisible && form.getFieldValue('BENEFBANKNAME_FILTER')) || ''
    const typed_adr =
      (modalVisible &&
        form
          .getFieldValue('BENEFBANKADDR_FILTER')
          ?.toString()
          ?.toLowerCase()) ||
      ''
    //COUNTRY

    if (typed_name.length >= 3 || typed_adr.length >= 3) {
      let data
      // setBankCodeSet(false)
      if (typed_adr.length >= 3) {
        data = await getBicCodesByCountryName(
          typed_adr?.toString()?.toUpperCase(),
          typed_name?.toString()?.toUpperCase()
        )
      } else {
        data = await getBicCodesByCountryName(
          '',
          typed_name?.toString()?.toUpperCase()
        )
      }

      let filter_codes = data
      if (typed_code !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.MAIN_BIC.toString().toLowerCase().includes(typed_code)
        )
      if (typed_adr !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.COUNTRY.toString().toLowerCase().includes(typed_adr)
        )
      if (typed_bank !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.BIC_CODE.toString().toLowerCase().includes(typed_bank)
        )
      // const filter_codes=data?.filter(row =>
      //     typed_code && typed_name ? row.BIC_CODE.includes(typed_code) && row.BANK_NAME.toString().toLowerCase().includes(typed_name) :
      //
      //         typed_code ? row.MAIN_BIC.includes(typed_code) : typed_name ? row.BANK_NAME.toString().toLowerCase().includes(typed_name) : row
      // );

      setFormFields((old_data) => ({
        ...old_data,
        // BENEFBANKCODE : typed_code,
        BENEFBANKNAME: typed_name,
      }))

      setBicCodes((old_data) => filter_codes)
      if (filter_codes !== undefined && filter_codes.length > 0) {
        setBankCodeSet(true)
      } else {
        setBankCodeSet(false)
      }
      // if(filter_codes?.length > 0)
      //     setToBranch(old_data => filter_codes[0]);
    } else if (typed_code.length >= 3) {
      // setBankCodeSet(false)
      const data = await getBicCodesByFilter(
        typed_code?.toString()?.toUpperCase()
      )

      let filter_codes = data
      if (typed_name !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.BANK_NAME.toString().toLowerCase().includes(typed_name)
        )
      if (typed_adr !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.COUNTRY.toString().toLowerCase().includes(typed_adr)
        )
      if (typed_bank !== '')
        filter_codes = filter_codes?.filter((row) =>
          row.BIC_CODE.toString().toLowerCase().includes(typed_bank)
        )
      // const filter_codes=data?.filter(row =>
      //     typed_code && typed_name ? row.BIC_CODE.includes(typed_code) && row.BANK_NAME.toString().toLowerCase().includes(typed_name) :
      //
      //         typed_code ? row.MAIN_BIC.includes(typed_code) : typed_name ? row.BANK_NAME.toString().toLowerCase().includes(typed_name) : row
      // );

      setFormFields((old_data) => ({
        ...old_data,
        /*BENEFBANKCODE : typed_code,*/
        BENEFBANKNAME: typed_name,
      }))

      setBicCodes((old_data) => filter_codes)

      if (filter_codes !== undefined && filter_codes.length > 0) {
        setBankCodeSet(true)
      } else {
        setBankCodeSet(false)
      }
      // if(filter_codes?.length > 0)
      //     setToBranch(old_data => filter_codes[0]);
    } else {
      setBicCodes((old_data) => [])
      setToBranch((old_data) => [])
      setBankCodeSet(false)
    }
    setSwiftModalVisible(modalVisible)
  }

  const updateToBicCodeAndName = (row) => {
    setFormFields((old_data) => ({
      ...old_data,
      BENEFBANKCODE: row.BIC_CODE,
      BENEFBANKNAME: row.BANK_NAME,
      BENEFBANKADDR: row.COUNTRY,
    }))
    setToBranch(row)
    setBankCodeSet(true)
    setSwiftModalVisible(false)
    setTimeout(() => {
      calculateCommission({ target: { value: form.getFieldValue('AMOUNT') } })
    }, 100)
  }

  const fetchData = async () => {
    setLoadingAccount(true)
    const data = await getAccounts(getCurrentCompany())

    let temp_data = []

    for (let row of data) {
      if (row.STATUS !== '0') {
        let lower_ccy_name = row.CCY_NAME.toString().toLowerCase()

        if (lower_ccy_name === 'rub' || lower_ccy_name === 'azn') {
          continue
        }
        const val = financial(row.BALANCE)
        // @ts-ignore
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${val !== undefined && val !== 'undefined' ? val : '0.00'} ${
            row.CCY_NAME
          }`,
        })
      }
    }

    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)

    /**/
    if (location?.state?.trnData) {
      fillCurrentForm(form, location.state.trnData)
    }
    setLoadingAccount(false)
  }

  useEffect(() => {
  form.setFieldsValue({
    BICINPUTTYPE: 'SWIFT',
  })

  resetDgkState()

  if (location.state?.data) loadData()
  else if (location.state?.trnData) loadDataTemplate2(location.state)
  else {
    fetchData()
    getBankcodesMethod()
  }
}, [location.state])

  useEffect(() => {
    form.setFieldsValue({
      BICINPUTTYPE: 'SWIFT',
    })
  }, [])
  const hydrateRepeatYgb = async (data: any) => {
  const ygbList = data?.ygb || [];
  if (!ygbList.length) return null;

  const pages = await Promise.all(
    ygbList.map(async (row: any) => {
      try {
        const res = await GetInfByGBNO({
          gbNo: row?.gbNumber,
          iban: data?.CUSTACC,
        });

        const api = res?.data || {};
        const contracts = api?.contracts || [];
        const details = api?.details || [];

        return {
          key: row?.gbNumber ?? "",
          gbNo: row?.gbNumber ?? "",
          summary: {
            name: api?.name ?? row?.customerFullname ?? null,
            taxId: api?.taxId ?? row?.taxNumber ?? null,
            receiverCountry: api?.receiverCountry ?? row?.beneficiaryCountry ?? null,
            invoiceCost: api?.invoiceCost ?? row?.ygbInvoiceCost ?? null,
            operationAmount: api?.operationAmount ?? row?.ygbOperationAmount ?? null,
            egbSum: api?.egbSum ?? row?.ygbRemainderAmount ?? null,
            invoiceCurrency: api?.invoiceCurrency ?? row?.ygbRemainderCcy ?? null,
            deliveryCondition: api?.deliveryCondition ?? row?.pmtCondition ?? null,
            bargainingFeature: api?.bargainingFeature ?? row?.ygbDeclareType ?? null,
            impDocDate: api?.impDocDate ?? row?.ygbImpDocDate ?? null,
            impDocCost: api?.impDocCost ?? row?.ygbDocCost ?? null,
            declarationTypeKey: api?.declarationTypeKey ?? row?.ygbDeclareTypeKey ?? null,
            senderOrExporter: api?.senderOrExporter ?? row?.ygbSender ?? null,
            goodOfServiceInfo: api?.goodOfServiceInfo ?? row?.goodServiceInfo ?? null,
            note: row?.note ?? api?.note ?? null,
            bankUserNumber: row?.bankUserNumber ?? null,
            pincode: api?.pincode ?? api?.pinCode ?? row?.ygbPincode ?? null,
          },
          contracts,
          details,
          filePath: api?.filePath ?? null,
          form: {
            gbNo: row?.gbNumber ?? "",
            name: api?.name ?? row?.customerFullname ?? "",
            receiverCountry: api?.receiverCountry ?? row?.beneficiaryCountry ?? "",
            invoiceCost: api?.invoiceCost ?? row?.ygbInvoiceCost ?? "",
            operationAmount: api?.operationAmount ?? row?.ygbOperationAmount ?? "",
            egbSum: api?.egbSum ?? row?.ygbRemainderAmount ?? "",
            contractNo: row?.contractNumber ?? "",
            contractDate: contracts.find((c: any) => c?.no === (row?.contractNumber ?? ""))?.date || formatDate(row?.ygbDate, "dash") || "",
            receiverCountryId: row?.countryCode != null ? String(row.countryCode) : undefined,
            receiverName: row?.beneficiaryName ?? "",
            transferredAmount: row?.ygbAmount ?? "",
            currencyType: row?.ccy ?? "",
            exchange: "",
          },
        };
      } catch (e) {
        console.error("YGB hydrate failed", row?.gbNumber, e);
        return null;
      }
    })
  );

  const filteredPages = pages.filter(Boolean);

  if (!filteredPages.length) return null;

  return {
    type: "YGB",
    iban: data?.CUSTACC ?? null,
    accountCurrency: data?.ccyType ?? null,
    pages: filteredPages,
  };
};
const hydrateRepeatAvans = async (data: any) => {
  const advanceList = data?.advance || [];
  if (!advanceList.length) return null;

  const pin = advanceList?.[0]?.pin;
  if (!pin) return null;

  try {
    const res = await GetInfByPinCode({
      pinCode: pin,
      iban: data?.CUSTACC,
    });

    const api = res?.data;
    if (!api) return null;

    const groupedContracts = (api?.contracts || []).map((contract: any, idx: number) => {
      const relatedDetails = (api?.details || []).filter(
        (d: any) =>
          String(d?.contract?.no || "") === String(contract?.no || "") &&
          String(d?.contract?.date || "") === String(contract?.date || "")
      );

      const firstDetail = relatedDetails[0];

      return {
        id: `${contract?.no || "contract"}-${idx}`,
        contractNo: contract?.no || "",
        contractDate: contract?.date || "",
        accountNo: firstDetail?.accountNo || "",
        country: firstDetail?.country || "",
        countryCode: firstDetail?.countryCode || "",
        bank: firstDetail?.bank || "",
        details: relatedDetails,
      };
    });

    const form: Record<string, any> = {};

    groupedContracts.forEach((contractRow: any, idx: number) => {
      const saved = advanceList.find(
        (a: any) => String(a?.advanceInvoiceNumber || "") === String(contractRow?.contractNo || "")
      );

      form[`contNo-${idx}`] = contractRow?.contractNo || "";
      form[`date-${idx}`] = formatDate(contractRow?.contractDate, "dot");
      form[`accountNo-${idx}`] = saved?.accountNumber || contractRow?.accountNo || "";
      form[`avansReceiverCountryId-${idx}`] = saved?.country || contractRow?.countryCode || undefined;
      form[`avansReceiver-${idx}`] = saved?.beneficiaryName || contractRow?.bank || "";
      form[`avansTransferredAmount-${idx}`] = saved?.advanceAmount || "";
      form[`avansCurrencyType-${idx}`] = saved?.ccy || "";
      form[`avansExchange-${idx}`] = "";
    });

    return {
      type: "Avans",
      iban: data?.CUSTACC ?? null,
      pinCode: pin,
      summary: {
        pinCode: api?.pinCode,
        taxId: api?.taxId,
        name: api?.name,
      },
      contracts: groupedContracts,
      details: api?.details || [],
      gbList: api?.gbList || [],
      form,
    };
  } catch (e) {
    console.error("Avans hydrate failed", pin, e);
    return null;
  }
};
const hydrateRepeatAkt = async (data: any) => {
  const actList = data?.act || [];
  if (!actList.length) return null;

  const countriesRes = await GetCustomerCountries();
  const countriesMap: Record<string, any> = countriesRes || {};

  const resolveCountry = (countryVal: any): { id: string | undefined; name: string | null } => {
    if (countryVal == null) return { id: undefined, name: null };
    const str = String(countryVal);
    if (countriesMap[str]) return { id: str, name: countriesMap[str]?.name ?? null };
    const entry = Object.entries(countriesMap).find(
      ([, c]: any) => String(c?.name || "").toLowerCase() === str.toLowerCase()
    );
    if (entry) return { id: String(entry[0]), name: (entry[1] as any)?.name ?? null };
    return { id: undefined, name: str };
  };

  return {
    type: "AKT",
    iban: data?.CUSTACC ?? null,
    taxId: getCurrentCompany()?.organizationCode ,
    pages: actList.map((row: any, idx: number) => {
      const country = resolveCountry(row?.country);
      return {
        key: `akt-${idx + 1}`,
        form: {
          actDocDate: formatDate(row?.actDocDate, "dash"),
          noActDocNumber: String(row?.noActDocNumber) === "true",
          actDocNumber: String(row?.noActDocNumber) === "true" ? undefined : row?.actDocNumber ?? "",
          actDocCost: row?.actDocCost ?? "",
          actTransCost: row?.actTransCost ?? "",
          currencyType: row?.ccyCode ?? "",
          actExchange: "",
          actSender: row?.actSender ?? "",
          actServiceProvider: String(row?.actServiceProvider) === "true",
          actServiceProviderName: String(row?.actServiceProvider) === "true" ? row?.actServiceProviderName ?? "" : "",
          countryId: country.id,
          countryName: country.name,
          goodServiceInfo: row?.goodServiceInfo ?? "",
          note: row?.note ?? "",
        },
      };
    }),
  };
};
const resetDgkState = () => {
  dispatch(setDgkData(null))
  setActiveCondition('')
  setPaymentConditionValue(undefined)
  form.setFieldsValue({
    paymentCondition: undefined,
  })
}
  const loadData = async () => {
    resetDgkState();
    console.log('isledi 0')
    const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
    setAmountCurrency(location.state?.data["pmtCurr"]);
    setFileList(pdf.data?.fileDetailsList)
    if (location.state?.edit) {
      setEdit(true)
    } else {
      setEdit(false)
    }
    setDocumentsCount(location.state.data['transferDocs']?.length)
    if (location.state.data['transferDocs']?.length > 0) {
      let i = 0
      let documentArr: any = {}
      location.state.data['transferDocs']?.map((row) => {
        documentArr = {
          key: i,
          docId: row.docId,
          docName: row.docName,
          docNameLabel: items.find((r) => r.value === row.docName)?.label,
          docNumAbsent: row.docNumAbsent.toString() === 'true' ? true : false,
          docNum: row.docNum,
          docDate: moment(row.docDate).format('YYYY-MM-DD'),
          docNote: row.docNote,
          isUsed: true,
        }
        documentsModalData[i] = documentArr
        createData[i] = documentArr
        i++
      })
      console.log(i)
    }
    setLoadingAccount(true)
    setLoadingData(true)
    const data = await getAccounts(getCurrentCompany())
    let temp_data = []
    for (let row of data) {
      if (row.STATUS !== '0') {
        let lower_ccy_name = row.CCY_NAME.toString().toLowerCase()
        if (lower_ccy_name === 'rub' || lower_ccy_name === 'azn') {
          continue
        }
        // @ts-ignore
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
        })
      }
    }
    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)
    setLoadingAccount(false)
    setTableData(location.state?.data)
    // setFileList(location.state?.data['PDF_LIST'])
    if (location.state?.edit) setIbankRef(location.state?.data['ibankRef'])
    setPdfCount(location.state?.data['attachedPDF'])
    const dataBankCodes = await getBankCodes()
    setAllBankCodes((old_data) => dataBankCodes)
    // CUSTACC
    const findAccount = data?.find(
      (row) => row.IBAN == location.state?.data['CUSTACC'] && row.STATUS !== '0'
    )
    if (findAccount !== undefined) {
      setFromBranch(findAccount)
      if (
        (form.getFieldValue('PMTCUSTID') === '' ||
          form.getFieldValue('PMTCUSTID') === undefined) &&
        location.state?.data['CUSTACC'] &&
        location.state?.edit === undefined
      ) {
        updateDocumentNumber()
      } else if (location.state?.edit) {
        form.setFieldsValue({
          PMTCUSTID: location.state?.data['PMTCUSTID'],
        })
      }
      form.setFieldsValue({
        CUSTACC: location.state?.data['CUSTACC'],
      })
    }
    form.setFieldsValue({
      transferDocs: location.state?.data['transferDocs'],
    })
    //BENEFNAME
    form.setFieldsValue({
      BENEFNAME: location.state?.data['BENEFNAME'],
    })
    // BENEFACC
    form.setFieldsValue({
      BENEFACC: location.state?.data['BENEFACC'],
    })
    // BENEFADDR
    form.setFieldsValue({
      BENEFADDR: location.state?.data['BENEFADDR'],
    })
    // AMOUNT
    form.setFieldsValue({
      AMOUNT: checkAmountForRequest(location.state?.data['AMOUNT']),
    })
    // PMTDET
   
    {
      const toVal = (v: any) => (v == null || v === 'null' ? '' : String(v).trim());
      const state = location.state as any;
      const pmtDet = toVal(state?.data?.['PMTDET']);
      const infoToBenef = toVal(state?.data?.['INFOTOBENEF']);
      form.setFieldsValue({
        PMTDET: [pmtDet, infoToBenef].filter(Boolean).join(' ') || '',
      });
    }
    // INFOTOBENEF
    // form.setFieldsValue({
    //   INFOTOBENEF: location.state?.data['INFOTOBENEF'],
    // })

    if (
      location.state?.data['BICINPUTTYPE'] !== undefined &&
      location.state?.data['BICINPUTTYPE'] !== null
    ) {
      const bankcode = location.state?.data['BENEFBANKCODE']
      switch (location.state?.data['BICINPUTTYPE']) {
        case 'ABA':
          const selected_option = options.find((row) => row.value == 3)
          setOptionValue((old_value) => 3)
          setSelectedOptionRow((old_data) => selected_option)
          form.setFieldsValue({
            BENEFBANKCODE: bankcode.replace('//F', ''),
          })
          form.setFieldsValue({
            BENEFBANKNAME: location.state?.data['BENEFBANKNAME'],
          })
          form.setFieldsValue({
            BENEFBANKADDR: location.state?.data['BENEFBANKADDR'],
          })
          setPrefix('//F')
          break
        case 'SORT':
          const selected_option1 = options.find((row) => row.value == 2)
          setOptionValue((old_value) => 2)
          setSelectedOptionRow((old_data) => selected_option1)
          setPrefix('//SC')

          form.setFieldsValue({
            BENEFBANKCODE: bankcode.replace('//SC', ''),
          })
          form.setFieldsValue({
            BENEFBANKNAME: location.state?.data['BENEFBANKNAME'],
          })
          form.setFieldsValue({
            BENEFBANKADDR: location.state?.data['BENEFBANKADDR'],
          })
          break
        case 'SWIFT':
          setPrefix('')
          const selected_option2 = options.find((row) => row.value == 1)
          const dataBicCodes = await getBicCodesByFilter(
            bankcode?.toString()?.toUpperCase()
          )
          setSelectedOptionRow((old_data) => selected_option2)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes)
          if (dataBicCodes?.length > 0) {
            setToBranch((old_data) => dataBicCodes[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes[0].COUNTRY,
          }))
          break
        case 'OTHER':
          setPrefix('') 
          const selected_option3 = options.find((row) => row.value == 4)
          setSelectedOptionRow((old_data) => selected_option3)
          setOptionValue((old_value) => 4)
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: bankcode,
            BENEFBANKNAME: location.state?.data['BENEFBANKNAME'],
            BENEFBANKADDR: location.state?.data['BENEFBANKADDR'],
          }))
          break
        default:
          const dataBicCodes1 = await getBicCodesByFilter(
            bankcode?.toString()?.toUpperCase()
          )
          const selected_option4 = options.find((row) => row.value == 1)
          setSelectedOptionRow((old_data) => selected_option4)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes1)
          if (dataBicCodes1?.length > 0) {
            setToBranch((old_data) => dataBicCodes1[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes1[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes1[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes1[0].COUNTRY,
          }))
          break
      }
    } else if (
      location.state?.data['BENEFBANKCODE'] !== null &&
      location.state?.data['BENEFBANKCODE'] !== undefined
    ) {
      const bankcode = location.state?.data['BENEFBANKCODE']
      if (bankcode.startsWith('//F')) {
        const selected_option = options.find((row) => row.value == 3)
        setOptionValue((old_value) => 3)
        setSelectedOptionRow((old_data) => selected_option)

        switch (selected_option?.value) {
          case 3:
            setPrefix('//F')
            break
          case 2:
            setPrefix('//SC')
            break
          default:
            setPrefix('')
            break
        }
        form.setFieldsValue({
          BENEFBANKCODE: bankcode.replace('//F', ''),
        })
        form.setFieldsValue({
          BENEFBANKNAME: location.state?.data['BENEFBANKNAME'],
        })
        form.setFieldsValue({
          BENEFBANKADDR: location.state?.data['BENEFBANKADDR'],
        })
      } else if (bankcode.startsWith('//SC')) {
        const selected_option = options.find((row) => row.value == 2)
        setOptionValue((old_value) => 2)
        setSelectedOptionRow((old_data) => selected_option)
        setPrefix('//SC')

        form.setFieldsValue({
          BENEFBANKCODE: bankcode.replace('//SC', ''),
        })
        form.setFieldsValue({
          BENEFBANKNAME: location.state?.data['BENEFBANKNAME'],
        })
        form.setFieldsValue({
          BENEFBANKADDR: location.state?.data['BENEFBANKADDR'],
        })
      } else {
        const dataBicCodes = await getBicCodesByFilter(
          bankcode?.toString()?.toUpperCase()
        )
        if (dataBicCodes?.length === 1) {
          const selected_option = options.find((row) => row.value == 1)
          setSelectedOptionRow((old_data) => selected_option)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes)
          if (dataBicCodes?.length > 0) {
            setToBranch((old_data) => dataBicCodes[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes[0].COUNTRY,
          }))
        } else {
          const selected_option = options.find((row) => row.value == 4)
          setSelectedOptionRow((old_data) => selected_option)
          setOptionValue((old_value) => 4)
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: bankcode,
            BENEFBANKNAME: location.state?.data['BENEFBANKNAME'],
            BENEFBANKADDR: location.state?.data['BENEFBANKADDR'],
          }))
        }
      }
    }

    if (
      location.state?.data['INTERMEDBANKCODE'] !== null &&
      location.state?.data['INTERMEDBANKCODE'] !== undefined
    ) {
      const dataBicCodeIntern = await getBicCodesByFilter(
        location.state?.data['INTERMEDBANKCODE']?.toString()?.toUpperCase()
      )
      setAllBankCodes((old_data) => dataBicCodeIntern)
      setBankCodes((old_data) => dataBicCodeIntern)
      if (dataBicCodeIntern?.length > 0) {
        setShowHideIntermediaryBank(true)
        setToBranchIntermed((old_data) => dataBicCodeIntern[0])
        setFormFields((old_data) => ({
          ...old_data,
          INTERMEDBANKCODE: dataBicCodeIntern[0].BIC_CODE,
          INTERMEDBANKNAME: dataBicCodeIntern[0].BANK_NAME,
          INTERMEDBANKADDR: dataBicCodeIntern[0].COUNTRY,
        }))
      }
    } else {
      setShowHideIntermediaryBank(false)
    }

    let valueAmount = checkAmountForRequest(location.state?.data['AMOUNT'])
    console.log("as",location.state?.data);
    
    if (!isNaN(valueAmount) && amountCurrency === 'USD') {
      setCommissionLoading(true)
      getCustomerCommission({
        PAYMENT_TYPE: 'SWIFT',
        CIF: getCurrentCompany().customerNo,
        CUSTACC: findAccount?.IBAN,
        AMOUNT: valueAmount,
        CUR: findAccount?.CCY_NAME,
        BENEFBANKCODE: location.state?.data['BENEFBANKCODE'],
        BENEFACC: location.state?.data['BENEFACC'],
        BENEFTAXID: location.state?.data['BENEFTAXID'],
        PMTDET: location.state?.data['PMTDET'],
      }).then((res) => {
        setCommissionLoading(false)
        form.setFieldsValue({
          COMMAMOUNT: res?.COM_AMOUNT ?? '',
        })
        setCommissionAmount((old_value) => res?.COM_AMOUNT ?? '')
      })
    } else {
      setCommissionLoading(false)
      form.setFieldsValue({
        COMMAMOUNT: '',
      })
      setCommissionAmount((old_value) => '')
    }
    const paymentOption = location.state?.data?.paymentOption || undefined;

setPaymentConditionValue(paymentOption);
form.setFieldsValue({
  paymentCondition: paymentOption,
});

const repeatDgkYgb = mapRepeatYgbToDgkState(location.state?.data);
const repeatDgkAdvance = mapRepeatAdvanceToDgkState(location.state?.data);
const repeatDgkAct = mapRepeatActToDgkState(location.state?.data);

if (repeatDgkYgb) {
  dispatch(setDgkData(repeatDgkYgb));
  setActiveCondition("YGB");
} else if (repeatDgkAdvance) {
  dispatch(setDgkData(repeatDgkAdvance));
  setActiveCondition("Avans");
} else if (repeatDgkAct) {
  dispatch(setDgkData(repeatDgkAct));
  setActiveCondition("AKT");
} else {
  dispatch(setDgkData(null));

  switch (paymentOption) {
    case "PREPAY_GOODS":
      setActiveCondition("Avans");
      break;
    case "POSTPAY_GOODS":
      setActiveCondition("YGB");
      break;
    case "POSTPAY_SERVICE":
      setActiveCondition("AKT");
      break;
    default:
      setActiveCondition("");
      break;
  }
}

const ygbHydrated = await hydrateRepeatYgb(location.state?.data);
if (ygbHydrated) {
  dispatch(setDgkData(ygbHydrated));
  setActiveCondition("YGB");
}

const aktHydrated = await hydrateRepeatAkt(location.state?.data);
if (aktHydrated) {
  dispatch(setDgkData(aktHydrated));
  setActiveCondition("AKT");
}

const avansHydrated = await hydrateRepeatAvans(location.state?.data);
if (avansHydrated) {
  dispatch(setDgkData(avansHydrated));
  setActiveCondition("Avans");
}
    setLoadingData(false)
  }

  const loadDataTemplate = async (tempData) => {
    console.log('isledi 1')
    setLoadingData(true)
    const docid = documentNumber
    form.resetFields()
    if (tempData?.trnData) {
      fillCurrentFormTemplate(form, tempData?.trnData)
      updateParentComponentFormData()
    }
    // console.log("ererre",tempData?.trnData?.pmtCurr);
    
  
    if (docid !== '' && docid !== undefined) {
      form.setFieldsValue({
        PMTCUSTID: docid,
      })
      setDocumentNumber((old_value) => docid)
    }

    setDocumentsCount(tempData?.trnData['transferDocs']?.length)
    if (tempData?.trnData['transferDocs']?.length > 0) {
      let i = 0
      let documentArr: any = {}
      tempData?.trnData['transferDocs']?.map((row) => {
        documentArr = {
          key: i,
          docId: row.docId,
          docName: row.docName,
          docNameLabel: items.find((r) => r.value === row.docName)?.label,
          docNumAbsent: row.docNumAbsent.toString() === 'true' ? true : false,
          docNum: row.docNum,
          docDate: moment(row.docDate).format('YYYY-MM-DD'),
          docNote: row.docNote,
          isUsed: true,
        }
        documentsModalData[i] = documentArr
        createData[i] = documentArr
        i++
      })
      console.log(i)
    }

    form.setFieldsValue({
      transferDocs: tempData?.trnData.transferDocs,
    })
    // CUSTACC
    const findAccount = allAccounts?.find(
      (row) => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== '0'
    )
    if (findAccount !== undefined) {
      setFromBranch(findAccount)
      // if (docid === "" || docid === undefined) {
      updateDocumentNumber()
      // }
      form.setFieldsValue({
        CUSTACC: tempData?.trnData.CUSTACC,
      })
    }
  
    if (tempData?.trnData?.pmtCurr) {
  setAmountCurrency(tempData.trnData.pmtCurr);
} else {
  setAmountCurrency(findAccount?.CCY_NAME);
}
    let valueAmount = checkAmountForRequest(tempData?.trnData.AMOUNT)
    if (!isNaN(valueAmount) && amountCurrency === 'USD') {
      setCommissionLoading(true)
      getCustomerCommission({
        PAYMENT_TYPE: 'SWIFT',
        CIF: getCurrentCompany().customerNo,
        CUSTACC: findAccount?.IBAN,
        AMOUNT: valueAmount,
        CUR: findAccount?.CCY_NAME,
        BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
        BENEFACC: tempData?.trnData.BENEFACC,
        BENEFTAXID: form.getFieldValue('BENEFTAXID'),
        PMTDET: tempData?.trnData.PMTDET,
      }).then((res) => {
        setCommissionLoading(false)
        form.setFieldsValue({
          COMMAMOUNT: res?.COM_AMOUNT ?? '',
        })
        setCommissionAmount((old_value) => res?.COM_AMOUNT ?? '')
      })
    } else {
      setCommissionLoading(false)
      form.setFieldsValue({
        COMMAMOUNT: '',
      })
      setCommissionAmount((old_value) => '')
    }

    form.setFieldsValue({
      AMOUNT: valueAmount,
    })

    if (
      tempData?.trnData.BICINPUTTYPE !== undefined &&
      tempData?.trnData.BICINPUTTYPE !== null
    ) {
      const bankcode = tempData?.trnData.BENEFBANKCODE
      switch (tempData?.trnData.BICINPUTTYPE) {
        case 'ABA':
          const selected_option = options.find((row) => row.value == 3)
          setOptionValue((old_value) => 3)
          setSelectedOptionRow((old_data) => selected_option)
          form.setFieldsValue({
            BENEFBANKCODE: bankcode.replace('//F', ''),
          })
          form.setFieldsValue({
            BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
          })
          form.setFieldsValue({
            BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
          })
          setPrefix('//F')
          break
        case 'SORT':
          const selected_option1 = options.find((row) => row.value == 2)
          setOptionValue((old_value) => 2)
          setSelectedOptionRow((old_data) => selected_option1)
          setPrefix('//SC')

          form.setFieldsValue({
            BENEFBANKCODE: bankcode.replace('//SC', ''),
          })
          form.setFieldsValue({
            BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
          })
          form.setFieldsValue({
            BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
          })
          break
        case 'SWIFT':
          setPrefix('')
          const selected_option2 = options.find((row) => row.value == 1)
          const dataBicCodes = await getBicCodesByFilter(
            bankcode?.toString()?.toUpperCase()
          )
          setSelectedOptionRow((old_data) => selected_option2)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes)
          if (dataBicCodes?.length > 0) {
            setToBranch((old_data) => dataBicCodes[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes[0].COUNTRY,
          }))
          break
        case 'OTHER':
          setPrefix('')
          const selected_option3 = options.find((row) => row.value == 4)
          setSelectedOptionRow((old_data) => selected_option3)
          setOptionValue((old_value) => 4)
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: bankcode,
            BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
            BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
          }))
          break
        default:
          const dataBicCodes1 = await getBicCodesByFilter(
            bankcode?.toString()?.toUpperCase()
          )
          const selected_option4 = options.find((row) => row.value == 1)
          setSelectedOptionRow((old_data) => selected_option4)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes1)
          if (dataBicCodes1?.length > 0) {
            setToBranch((old_data) => dataBicCodes1[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes1[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes1[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes1[0].COUNTRY,
          }))
          break
      }
    } else if (
      tempData?.trnData.BENEFBANKCODE !== null &&
      tempData?.trnData.BENEFBANKCODE !== undefined
    ) {
      const bankcode = tempData?.trnData.BENEFBANKCODE
      if (bankcode.startsWith('//F')) {
        const selected_option = options.find((row) => row.value == 3)
        setOptionValue((old_value) => 3)
        setSelectedOptionRow((old_data) => selected_option)

        switch (selected_option?.value) {
          case 3:
            setPrefix('//F')
            break
          case 2:
            setPrefix('//SC')
            break
          default:
            setPrefix('')
            break
        }
        form.setFieldsValue({
          BENEFBANKCODE: bankcode.replace('//F', ''),
        })
        form.setFieldsValue({
          BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
        })
        form.setFieldsValue({
          BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
        })
      } else if (bankcode.startsWith('//SC')) {
        const selected_option = options.find((row) => row.value == 2)
        setOptionValue((old_value) => 2)
        setSelectedOptionRow((old_data) => selected_option)
        setPrefix('//SC')

        form.setFieldsValue({
          BENEFBANKCODE: bankcode.replace('//SC', ''),
        })
        form.setFieldsValue({
          BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
        })
        form.setFieldsValue({
          BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
        })
      } else {
        const dataBicCodes = await getBicCodesByFilter(
          bankcode?.toString()?.toUpperCase()
        )
        if (dataBicCodes?.length === 1) {
          const selected_option = options.find((row) => row.value == 1)
          setSelectedOptionRow((old_data) => selected_option)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes)
          if (dataBicCodes?.length > 0) {
            setToBranch((old_data) => dataBicCodes[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes[0].COUNTRY,
          }))
        } else {
          const selected_option = options.find((row) => row.value == 4)
          setSelectedOptionRow((old_data) => selected_option)
          setOptionValue((old_value) => 4)
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: bankcode,
            BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
            BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
          }))
        }
      }
    }

    if (
      tempData?.trnData.INTERMEDBANKCODE !== null &&
      tempData?.trnData.INTERMEDBANKCODE !== undefined
    ) {
      const dataBicCodeIntern = await getBicCodesByFilter(
        tempData?.trnData.INTERMEDBANKCODE?.toString()?.toUpperCase()
      )
      setAllBankCodes((old_data) => dataBicCodeIntern)
      setBankCodes((old_data) => dataBicCodeIntern)
      if (dataBicCodeIntern?.length > 0) {
        setToBranchIntermed((old_data) => dataBicCodeIntern[0])
        setShowHideIntermediaryBank(true)
        setFormFields((old_data) => ({
          ...old_data,
          INTERMEDBANKCODE: dataBicCodeIntern[0].BIC_CODE,
          INTERMEDBANKNAME: dataBicCodeIntern[0].BANK_NAME,
          INTERMEDBANKADDR: dataBicCodeIntern[0].COUNTRY,
        }))
      }
    } else {
      setShowHideIntermediaryBank(false)
    }
    console.log(tempData?.trnData.PMTDET)
     form.setFieldsValue({
      PMTDET:  tempData?.trnData.INFOTOBENEF !== null && tempData?.trnData.INFOTOBENEF !== undefined ?  (tempData?.trnData.PMTDET !==undefined && tempData?.trnData.PMTDET !==null ?tempData?.trnData.PMTDET?.trim()+ " "+ tempData?.trnData.INFOTOBENEF:tempData?.trnData.INFOTOBENEF):tempData?.trnData.PMTDET?.trim(),
    })
    setSaveDocuments( tempData?.trnData.INFOTOBENEF !== null && tempData?.trnData.INFOTOBENEF !== undefined ?  (tempData?.trnData.PMTDET !==undefined && tempData?.trnData.PMTDET !==null ?tempData?.trnData.PMTDET?.trim()+ " "+ tempData?.trnData.INFOTOBENEF:tempData?.trnData.INFOTOBENEF):tempData?.trnData.PMTDET?.trim())

    setLoadingData(false)
  }

  const loadDataTemplate2 = async (tempData) => {
    console.log('isledi 2')
    // console.log("ererre",tempData?.amountCurr);
    onCloseSuccessModal()
    setLoadingAccount(true)
    setLoadingData(true)
    
    const data = await getAccounts(getCurrentCompany())
    let temp_data = []
    for (let row of data) {
      if (row.STATUS !== '0') {
        let lower_ccy_name = row.CCY_NAME.toString().toLowerCase()
        if (lower_ccy_name === 'rub' || lower_ccy_name === 'azn') {
          continue
        }
        // @ts-ignore
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
        })
      }
    }
    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)
    setLoadingAccount(false)
    setDocumentsCount(tempData?.trnData['transferDocs']?.length)

        console.log("ererre",tempData?.trnData);
   
    // if(tempData?.trnData?.pmtCurr){
    //   console.log('isledi load2 if')

    //   setSetted(true);
    //   setAmountCurrency(tempData?.trnData?.pmtCurr);
    // }else{
    //   console.log('isledi load2 else')

    //   setAmountCurrency(fromBranch?.CCY_NAME);
    // }
    if (tempData?.trnData['transferDocs']?.length > 0) {
      let i = 0
      let documentArr: any = {}
      tempData?.trnData['transferDocs']?.map((row) => {
        documentArr = {
          key: i.toString(),
          docId: row.docId.toString(),
          docName: row.docName,
          docNameLabel: items.find((r) => r.value === row.docName)?.label,
          docNumAbsent: row.docNumAbsent.toString() === 'true' ? true : false,
          docNum: row.docNum,
          docDate: moment(row.docDate).format('YYYY-MM-DD'),
          docNote: row.docNote,
          isUsed: true,
        }
        documentsModalData[i] = documentArr
        createData[i] = documentArr

        i++
      })

      console.log(i)
      setcreateData(createData)

      form.setFieldsValue({
        transferDocs: createData,
      })
      setModalDataDocuments(documentsModalData)
    }
    const dataBankCodes = await getBankCodes()
    setAllBankCodes((old_data) => dataBankCodes)
    if (location?.state?.trnData) {
      fillCurrentForm(form, location.state.trnData)
    }
    // CUSTACC
    const findAccount = data?.find(
      (row) => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== '0'
    )
    if (findAccount !== undefined) {
      setFromBranch(findAccount)
      // if (form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) {
      await updateDocumentNumber()
      // }
      form.setFieldsValue({
        CUSTACC: tempData?.trnData.CUSTACC,
      })
    }

    if (tempData?.trnData?.pmtCurr) {
  setAmountCurrency(tempData.trnData.pmtCurr);
} else {
  setAmountCurrency(findAccount?.CCY_NAME);
}
    let valueAmount = checkAmountForRequest(tempData?.trnData.AMOUNT)
    if (!isNaN(valueAmount) && amountCurrency === 'USD') {
      setCommissionLoading(true)
      const res = await getCustomerCommission({
        PAYMENT_TYPE: 'SWIFT',
        CIF: getCurrentCompany().customerNo,
        CUSTACC: findAccount?.IBAN,
        AMOUNT: valueAmount,
        CUR: findAccount?.CCY_NAME,
        BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
        BENEFACC: tempData?.trnData.BENEFACC,
        BENEFTAXID: form.getFieldValue('BENEFTAXID'),
        PMTDET: tempData?.trnData.PMTDET,
      })

      if (res !== undefined) {
        setCommissionLoading(false)
        form.setFieldsValue({
          COMMAMOUNT: res?.COM_AMOUNT ?? '',
        })
        setCommissionAmount((old_value) => res?.COM_AMOUNT ?? '')
      }
    } else {
      setCommissionLoading(false)
      form.setFieldsValue({
        COMMAMOUNT: '',
      })
      setCommissionAmount((old_value) => '')
    }
    form.setFieldsValue({
      AMOUNT: valueAmount,
    })
    console.log(tempData.trnData)
     form.setFieldsValue({
      PMTDET:  tempData?.trnData.INFOTOBENEF !== null && tempData?.trnData.INFOTOBENEF !== undefined ?  (tempData?.trnData.PMTDET !==undefined && tempData?.trnData.PMTDET !==null ?tempData?.trnData.PMTDET?.trim()+ " "+ tempData?.trnData.INFOTOBENEF:tempData?.trnData.INFOTOBENEF):tempData?.trnData.PMTDET?.trim(),
    })
    setSaveDocuments( tempData?.trnData.INFOTOBENEF !== null && tempData?.trnData.INFOTOBENEF !== undefined ?  (tempData?.trnData.PMTDET !==undefined && tempData?.trnData.PMTDET !==null ?tempData?.trnData.PMTDET?.trim()+ " "+ tempData?.trnData.INFOTOBENEF:tempData?.trnData.INFOTOBENEF):tempData?.trnData.PMTDET?.trim())
    // form.setFieldsValue({
    //     'transferDocs': tempData?.trnData.transferDocs
    // });

    if (
      tempData?.trnData.BICINPUTTYPE !== undefined &&
      tempData?.trnData.BICINPUTTYPE !== null
    ) {
      const bankcode = tempData?.trnData.BENEFBANKCODE
      switch (tempData?.trnData.BICINPUTTYPE) {
        case 'ABA':
          const selected_option = options.find((row) => row.value == 3)
          setOptionValue((old_value) => 3)
          setSelectedOptionRow((old_data) => selected_option)
          form.setFieldsValue({
            BENEFBANKCODE: bankcode.replace('//F', ''),
          })
          form.setFieldsValue({
            BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
          })
          form.setFieldsValue({
            BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
          })
          setPrefix('//F')
          break
        case 'SORT':
          const selected_option1 = options.find((row) => row.value == 2)
          setOptionValue((old_value) => 2)
          setSelectedOptionRow((old_data) => selected_option1)
          setPrefix('//SC')

          form.setFieldsValue({
            BENEFBANKCODE: bankcode.replace('//SC', ''),
          })
          form.setFieldsValue({
            BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
          })
          form.setFieldsValue({
            BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
          })
          break
        case 'SWIFT':
          setPrefix('')
          const selected_option2 = options.find((row) => row.value == 1)
          const dataBicCodes = await getBicCodesByFilter(
            bankcode?.toString()?.toUpperCase()
          )
          setSelectedOptionRow((old_data) => selected_option2)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes)
          if (dataBicCodes?.length > 0) {
            setToBranch((old_data) => dataBicCodes[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes[0].COUNTRY,
          }))
          break
        case 'OTHER':
          setPrefix('')
          const selected_option3 = options.find((row) => row.value == 4)
          setSelectedOptionRow((old_data) => selected_option3)
          setOptionValue((old_value) => 4)
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: bankcode,
            BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
            BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
          }))
          break
        default:
          const dataBicCodes1 = await getBicCodesByFilter(
            bankcode?.toString()?.toUpperCase()
          )
          const selected_option4 = options.find((row) => row.value == 1)
          setSelectedOptionRow((old_data) => selected_option4)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes1)
          if (dataBicCodes1?.length > 0) {
            setToBranch((old_data) => dataBicCodes1[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes1[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes1[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes1[0].COUNTRY,
          }))
          break
      }
    } else if (
      tempData?.trnData.BENEFBANKCODE !== null &&
      tempData?.trnData.BENEFBANKCODE !== undefined
    ) {
      const bankcode = tempData?.trnData.BENEFBANKCODE
      if (bankcode.startsWith('//F')) {
        const selected_option = options.find((row) => row.value == 3)
        setOptionValue((old_value) => 3)
        setSelectedOptionRow((old_data) => selected_option)

        switch (selected_option?.value) {
          case 3:
            setPrefix('//F')
            break
          case 2:
            setPrefix('//SC')
            break
          default:
            setPrefix('')
            break
        }
        form.setFieldsValue({
          BENEFBANKCODE: bankcode.replace('//F', ''),
        })
        form.setFieldsValue({
          BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
        })
        form.setFieldsValue({
          BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
        })
      } else if (bankcode.startsWith('//SC')) {
        const selected_option = options.find((row) => row.value == 2)
        setOptionValue((old_value) => 2)
        setSelectedOptionRow((old_data) => selected_option)
        setPrefix('//SC')

        form.setFieldsValue({
          BENEFBANKCODE: bankcode.replace('//SC', ''),
        })
        form.setFieldsValue({
          BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
        })
        form.setFieldsValue({
          BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
        })
      } else {
        const dataBicCodes = await getBicCodesByFilter(
          bankcode?.toString()?.toUpperCase()
        )
        if (dataBicCodes?.length === 1) {
          const selected_option = options.find((row) => row.value == 1)
          setSelectedOptionRow((old_data) => selected_option)
          setOptionValue((old_value) => 1)
          setBicCodes((old_data) => dataBicCodes)
          if (dataBicCodes?.length > 0) {
            setToBranch((old_data) => dataBicCodes[0])
            setBankCodeSet(true)
          }
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: dataBicCodes[0].BIC_CODE,
            BENEFBANKNAME: dataBicCodes[0].BANK_NAME,
            BENEFBANKADDR: dataBicCodes[0].COUNTRY,
          }))
        } else {
          const selected_option = options.find((row) => row.value == 4)
          setSelectedOptionRow((old_data) => selected_option)
          setOptionValue((old_value) => 4)
          setFormFields((old_data) => ({
            ...old_data,
            BENEFBANKCODE: bankcode,
            BENEFBANKNAME: tempData?.trnData.BENEFBANKNAME,
            BENEFBANKADDR: tempData?.trnData.BENEFBANKADDR,
          }))
        }
      }
    }

    if (
      tempData?.trnData.INTERMEDBANKCODE !== null &&
      tempData?.trnData.INTERMEDBANKCODE !== undefined &&
      tempData?.trnData.INTERMEDBANKCODE !== ''
    ) {
      const dataBicCodeIntern = await getBicCodesByFilter(
        tempData?.trnData.INTERMEDBANKCODE?.toString()?.toUpperCase()
      )
      setAllBankCodes((old_data) => dataBicCodeIntern)
      setBankCodes((old_data) => dataBicCodeIntern)
      if (dataBicCodeIntern?.length > 0) {
        setToBranchIntermed((old_data) => dataBicCodeIntern[0])
        setShowHideIntermediaryBank(true)
        setFormFields((old_data) => ({
          ...old_data,
          INTERMEDBANKCODE: dataBicCodeIntern[0].BIC_CODE,
          INTERMEDBANKNAME: dataBicCodeIntern[0].BANK_NAME,
          INTERMEDBANKADDR: dataBicCodeIntern[0].COUNTRY,
        }))
      }
    } else {
      setShowHideIntermediaryBank(false)
    }

    updateParentComponentFormData()
    setLoadingData(false)
  }

  const onOptionsChange = (e) => {
    setFormFields((old_data) => ({
      ...old_data,
      BENEFBANKCODE: '',
      BENEFBANKNAME: '',
      BENEFBANKADDR: '',
    }))

    const new_val = e.target.value
    const selected_option = options.find((row) => row.value == new_val)
    setOptionValue((old_value) => new_val)
    setSelectedOptionRow((old_data) => selected_option)
    switch (selected_option?.value) {
      case 3:
        setPrefix('//F')
        form.setFieldsValue({
          BICINPUTTYPE: 'ABA',
        })
        break
      case 2:
        setPrefix('//SC')
        form.setFieldsValue({
          BICINPUTTYPE: 'SORT',
        })
        break
      case 1:
        form.setFieldsValue({
          BICINPUTTYPE: 'SWIFT',
        })
        break
      case 4:
        form.setFieldsValue({
          BICINPUTTYPE: 'OTHER',
        })
        break
      default:
        setPrefix('')
        form.setFieldsValue({
          BICINPUTTYPE: 'SWIFT',
        })
        break
    }
  }
  const updateDocumentNumber = async () => {
    const document_number = await getSwiftDocumentNumber(getCurrentCompany())
    form.setFieldsValue({
      PMTCUSTID: document_number,
    })

    setDocumentNumber((old_value) => document_number)
  }

  const getSelectedFromBranch = (value: any) => {
    const findAccount = allAccounts?.find((row) => row.IBAN == value)
    setFromBranch(findAccount)
  setAmountCurrency(findAccount?.CCY_NAME);
    if (!form.getFieldValue('PMTCUSTID') && value) {
      updateDocumentNumber()
    }
  }

  useEffect(() => {
    if (
      ibanNumber.iban &&
      allAccounts &&
      ibanNumber.ccy_name?.toString()?.toLowerCase() !== 'azn' &&
      ibanNumber.ccy_name?.toString()?.toLowerCase() !== 'rub'
    ) {
      const findAccount = allAccounts?.find(
        (row) => row.IBAN == ibanNumber.iban
      )
      setFromBranch(findAccount)

      if (!form.getFieldValue('PMTCUSTID') && ibanNumber.iban) {
        updateDocumentNumber()
      }

      setIbanNumber({ iban: undefined, ccy_name: undefined })
    }
  }, [ibanNumber, allAccounts])

useEffect(() => {
  setPdfCount(form.getFieldValue('pdf_files')?.length)
},[form.getFieldValue('pdf_files')])
  const getDgkTransferredTotal = () => {
  const value = checkAmountForRequest(dgkData?.total_exchange_amount)
  return isNaN(value) ? 0 : Number(value)
}
  const isDgkCompleted = () => {
  if (!paymentConditionValue) return false;

  if (
    paymentConditionValue === "PREPAY_SERVICE" ||
    paymentConditionValue === "OTHER"
  ) {
    return true;
  }

  if (!dgkData?.type) return false;

  if (dgkData.type === "YGB") {
    return Array.isArray(dgkData.pages) && dgkData.pages.length > 0;
  }

  if (dgkData.type === "AKT") {
    return Array.isArray(dgkData.pages) && dgkData.pages.length > 0;
  }

  if (dgkData.type === "Avans" || dgkData.type === "AVANS") {
    return Array.isArray(dgkData.contracts) && dgkData.contracts.length > 0;
  }

  return false;
};
const isTransferAmountLessThanDgkTotal = () => {
  // dgkTotal is stored in the account currency. When the amount is entered in a
  // different currency (cross-currency USD account), compare against the
  // converted amount (infoData.exchAmount) rather than the raw AMOUNT, otherwise
  // we'd be comparing e.g. 200 NOK against a USD total and the check never trips.
  const rawAmount =
    openCrossMessage && !isNaN(Number(infoData?.exchAmount))
      ? Number(infoData.exchAmount)
      : checkAmountForRequest(form.getFieldValue("AMOUNT"));
  const dgkTotal = getDgkTransferredTotal();

  if (!paymentConditionValue || !dgkData?.type || dgkTotal <= 0) return false;

  // An empty/invalid amount counts as 0 — with a DGK total present, "no amount"
  // is still less than the accumulated total, so the error must show (and stay
  // consistent instead of flickering based on stale converted values).
  const transferAmountValue = isNaN(Number(rawAmount)) ? 0 : Number(rawAmount);

  return transferAmountValue < Number(dgkTotal);
};
const hasDgkAmountError = isTransferAmountLessThanDgkTotal();
  const newTransferFunc =async (RequestType: string, retry: boolean = false) => {
    let amount = checkAmountForRequest(form.getFieldValue('AMOUNT'))
    let comission = checkAmountForRequest(form.getFieldValue('COMMAMOUNT'))
    const creatDocData: any = []
 if(ibankRef !== "") {
       await   deleteFileById(ibankRef)
       await new Promise(res => setTimeout(res, 1000)); 
      }
    createData?.map((row: any, index: any) => {
      creatDocData.push({
        docId: index + 1,
        docName: row?.docName,
        docNumAbsent: row?.docNumAbsent,
        docNum: row?.docNum,
        docDate: row?.docDate,
        docNote: row?.docNote,
      })
    })

    if (!retry && retryRequest === null) {
      const dgkPayload = buildDgkPayload();
      const req = {
        trnRequestType: RequestType,
        ccy: 1,
        ccyType: fromBranch?.CCY_NAME,
        PMTCUSTID: form.getFieldValue('PMTCUSTID'),
        CUSTCIF: getCurrentCompany().customerNo,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: amount,
        BENEFNAME: form.getFieldValue('BENEFNAME'),
        BENEFADDR: form.getFieldValue('BENEFADDR'),
        BENEFACC: form.getFieldValue('BENEFACC')?.toUpperCase(),
        BENEFBANKCODE: prefix + form.getFieldValue('BENEFBANKCODE'),
        BENEFBANKNAME: form.getFieldValue('BENEFBANKNAME'),
        BENEFBANKADDR: form.getFieldValue('BENEFBANKADDR'),
        INTERMEDBANKCODE: showHideIntermediaryBank
          ? form.getFieldValue('INTERMEDBANKCODE') ?? null
          : null,
        INTERMEDBANKNAME: showHideIntermediaryBank
          ? form.getFieldValue('INTERMEDBANKNAME') ?? null
          : null,
        INTERMEDBANKADDR: showHideIntermediaryBank
          ? form.getFieldValue('INTERMEDBANKADDR') ?? null
          : null,
        PMTDET: form.getFieldValue('PMTDET'),
        // INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
        NOTE: form.getFieldValue('NOTE'),
        accCurr:fromBranch?.CCY_NAME,
        pmtCurr:fromBranch?.CCY_NAME === 'USD' ? amountCurrency : fromBranch?.CCY_NAME,
        exchAmount:infoData?.exchAmount,
        rate:infoData?.rate,
        rateDate:infoData?.rateDate,
        CUSTACCFORCOM: fromBranch?.IBAN,
        COMMAMOUNT: comission,
        ibankRef: ibankRef,
        attachedPDF: pdfCount,
        BICINPUTTYPE: form.getFieldValue('BICINPUTTYPE'),
        transferDocs: creatDocData,
        paymentOption:form.getFieldValue("paymentCondition"),
        paymentDurationCondition:
          paymentConditionValue === "PREPAY_SERVICE" ? "4" :
          paymentConditionValue === "OTHER" ? null :
          paymentConditionValue === "POSTPAY_GOODS" ? "1" :
          paymentConditionValue === "POSTPAY_SERVICE" ? "2" :
          paymentConditionValue === "PREPAY_GOODS" ? "3" :
          undefined,
        ...dgkPayload,
      }
      setRetryRequest(req)
      const data = newMoneyTransferSwift(req)
      // resetForm(form);
      // resetFormFields();
      // setFormFields(old_data => ({
      //     ...old_data,
      //     BENEFBANKCODE : '',
      //     BENEFBANKNAME : '',
      //     BENEFBANKADDR : '',
      // }));
      // setCommissionAmount('');
      return data
    } else {
      if (retryRequest !== null) retryRequest['trnRequestType'] = RequestType
      const data = newMoneyTransferSwift(retryRequest)
      // resetForm(form);
      // resetFormFields();
      // setCommissionAmount('');
      // setFormFields(old_data => ({
      //     ...old_data,
      //     BENEFBANKCODE : '',
      //     BENEFBANKNAME : '',
      //     BENEFBANKADDR : '',
      // }));
      // setCommissionAmount('');
      return data
    }
  }

  const onCloseSuccessModal = () => {

  dispatch(setDgkData(null))
  setActiveCondition('')
  setPaymentConditionValue(undefined)

  resetForm(form)
  resetFormFields()
  setRefreshDocuments(true)
  setDocumentsCount(0)
  setCommissionAmount('')
  setFormFields((old_data) => ({
    ...old_data,
    BENEFBANKCODE: '',
    BENEFBANKNAME: '',
    BENEFBANKADDR: '',
  }))
  form.setFieldsValue({
    BICINPUTTYPE: 'SWIFT',
    PMTDET: '',
    paymentCondition: undefined,
  })
  saveDocumentsModal(dataDocumentModal)
  }
useEffect(() => {
  if (!fromBranch?.CCY_NAME) return;

  // 1) İlk açılışda REDAKTƏ datası varsa, currency-ni OVERRIDE ETMƏ
  if (location.state && !setted) {
    // İlk dəfə redaktə dəyərini qoruyuruq
    setSetted(true);
    return;
  }

  // 2) Əgər istifadəçi HESABI dəyişibsə → currency yenilənməlidir
 if (setted) {
  setAmountCurrency(fromBranch.CCY_NAME);
}
}, [fromBranch?.CCY_NAME]);


  const submitHandler = async (args: any) => {
    // Server-of-record guard: the "Next" button's `disabled` prop is only a UI
    // hint and can be stripped via devtools. Re-enforce the same rules here so a
    // tampered/forced submit with an incomplete DGK (customs) selection — or a
    // transfer amount below the DGK total — is still rejected before proceeding.
    if (!isDgkCompleted()) {
      message.warning(t('dgk.fillDgkWarning'))
      return
    }
    if (isTransferAmountLessThanDgkTotal()) {
      message.warning(t('dgk.amountLessThanDgkWarning'))
      return
    }

    console.log("Before commission");
    const result = await calculateCommission(args.AMOUNT);
    console.log("After commission, result:", result);
    let amount = financial(form.getFieldValue('AMOUNT'))
    let comission = financial(form.getFieldValue('COMMAMOUNT'))

    let pdf_files = form.getFieldValue('pdf_files') ?? []
    modalDataInitial.pdfFiles = []

    if (pdf_files.length > 0) {
      for (let file of pdf_files) {
        modalDataInitial.pdfFiles.push({
          label: file.name,
          file: file,
        })
      }
    }

    let check_vasiteci = showHideIntermediaryBank
      ? {
          title: t('newTransfer.intermediaryBank'),
          // tableHasBorderBottom2 : true,
          data: [
            {
              label: t('transfers.swiftCode'),
              value: args.INTERMEDBANKCODE ?? '',
            },
            {
              label: t('requisites.name'),
              value: args.INTERMEDBANKNAME ?? '',
            },
            {
              label: t('transfers.address'),
              value: args.INTERMEDBANKADDR ?? '',
            },
            // {
            //     label : '',
            //     value : '',
            //     rowClass : 'empty_row'
            // }
          ],
        }
      : {}

    setModalData((old_data) => ({
      ...modalDataInitial,
      groups: [
        {
          title: false,
          tableHasBorderBottom: true,
          data: [
            {
              label: t('transfers.sender'),
              value: getCurrentCompany().name,
            },
            {
              label: t('salary.documentNo'),
              value: `${args.PMTCUSTID}`,
            },
            {
              label: t('transfers.fromAccount'),
              value: `${fromBranch?.IBAN} ${fromBranch?.CCY_NAME}`,
            },
          ],
        },
        {
          title: t('requisites.beneficiary'),
          tableHasBorderBottom: true,
          tableHasMarginBottom: true,
          data: [
            {
              label: t('requisites.name'),
              value: `${args.BENEFNAME}`,
            },
            {
              label: t('transfers.accountNumber'),
              value: `${args.BENEFACC?.toUpperCase()}`,
            },
            {
              label: t('transfers.address'),
              value: `${args.BENEFADDR}`,
            },
          ],
        },
        {
          title: t('requisites.beneficiaryBank'),
          // tableHasBorderBottom2 : true,
          // tableHasMarginBottom : true,
          data: [
            {
              label: selectedOptionRow?.title,
              value: `${prefix}` + `${args.BENEFBANKCODE}`,
            },
            {
              label: t('requisites.name'),
              value: `${args.BENEFBANKNAME}`,
            },
            {
              label: t('transfers.address'),
              value: `${args.BENEFBANKADDR}`,
            },
          ],
        },
        check_vasiteci,
        {
          title: '',
          data: [
            {
              label: t('common.amount'),
            value: `${amount} ${fromBranch?.CCY_NAME ==='USD' ? amountCurrency : fromBranch?.CCY_NAME}`,
            },
            {
              label: t('home.commission'),
              value: `${comission} ${fromBranch?.CCY_NAME}`,
            },
            {
              label: t("dgk.payment_terms"),
              value:
                paymentOptions.find((item) => item.value === form.getFieldValue("paymentCondition"))?.label || "",
            },
            {
              label: t('accountStatement.paymentDetails'),
              value: args.PMTDET ?? '',
            },
            // {
            //   label: t('transfers.infoForBeneficiary'),
            //   value: args.INFOTOBENEF ?? '',
            // },
            args.NOTE !== undefined
              ? {
                  label: t('newTransfer.note'),
                  value: args.NOTE ?? '',
                }
              : undefined,
          ],
        },
      ],
    }))

    setNextModalVisible((old_value) => true)
  }

  const getFileList = (info: any) => {
    form.setFieldsValue({
      pdf_files: info.fileList,
    })
  }

  useEffect(()=>{
    console.log("wer",form.getFieldValue('AMOUNT'));
    calculateCommission(form.getFieldValue('AMOUNT'))
  },[amountCurrency,form.getFieldValue('AMOUNT')])


  const calculateCommission = async (e: any) => {
  let value;
  console.log("aw",e);
  if (e?.target !== undefined) {
    value = checkAmountForRequest(e.target.value);
  } else {
    value = checkAmountForRequest(e);
  }
console.log("aw3",value);
  if (!isNaN(value)) {
    setCommissionLoading(true);
    console.log("aw1",amountCurrency);
    try {
      let res;
     if(fromBranch?.CCY_NAME === 'USD' && amountCurrency !== 'USD'){
      setInfoData({});
          const resCross:any = await getcrosscurrency({
          "accCurr":  fromBranch?.CCY_NAME, 
          "pmtAmount": value, 
          "pmtCurr": amountCurrency
      })
      setCurrAmount(value);
      setInfoData(resCross?.data);
      setOpenCrossMessage(true);
      if(resCross.message === 'SUCCESS'){
       res = await getCustomerCommission({
        PAYMENT_TYPE: "SWIFT",
        CIF: getCurrentCompany().customerNo,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: checkAmountForRequest(resCross?.data?.exchAmount),
        CUR: fromBranch?.CCY_NAME,
        BENEFBANKCODE: form.getFieldValue("BENEFBANKCODE"),
        BENEFACC: form.getFieldValue("BENEFACC")?.toUpperCase(),
        BENEFTAXID: form.getFieldValue("BENEFTAXID"),
        PMTDET: form.getFieldValue("PMTDET"),
      });

      }
     }else{
      setOpenCrossMessage(false);
      setInfoData({});
      res = await getCustomerCommission({
        PAYMENT_TYPE: "SWIFT",
        CIF: getCurrentCompany().customerNo,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: value,
        CUR: fromBranch?.CCY_NAME,
        BENEFBANKCODE: form.getFieldValue("BENEFBANKCODE"),
        BENEFACC: form.getFieldValue("BENEFACC")?.toUpperCase(),
        BENEFTAXID: form.getFieldValue("BENEFTAXID"),
        PMTDET: form.getFieldValue("PMTDET"),
      });
     }
 
      
      setCommissionLoading(false);

      form.setFieldsValue({
        COMMAMOUNT: res?.COM_AMOUNT ?? "",
      });

      setCommissionAmount(res?.COM_AMOUNT ?? "");

      return res?.COM_AMOUNT ?? "";
    } catch (err) {
      setCommissionLoading(false);
      console.error("Commission fetch error:", err);
      return "";
    }
  } else {
    console.log("aw2",amountCurrency);
    setCommissionLoading(false);

    // Amount was cleared/invalid — reset the cross-currency state too, otherwise
    // openCrossMessage/infoData.exchAmount keep the previous converted value and
    // the DGK "total less than" validation keeps comparing against a stale amount.
    setOpenCrossMessage(false);
    setInfoData({});

    form.setFieldsValue({
      COMMAMOUNT: "",
    });

    setCommissionAmount("");

    return "";
  }
};


  const openSaveAsTemplateModal = () => {
    setSaveAsTemplatePopupVisible((old_data) => false)

    form
      .validateFields()
      .then((res) => {
        setSaveAsTemplatePopupVisible((old_data) => true)
        const creatDocData: any = []

        createData?.map((row: any, index: any) => {
          creatDocData.push({
            docId: index + 1,
            docName: row?.docName,
            docNumAbsent: row?.docNumAbsent,
            docNum: row?.docNum,
            docDate: row?.docDate,
            docNote: row?.docNote,
          })
        })
        
        setDocumentsData(creatDocData)
      })
      .catch((err_input_list) => {})
  }

  const updateDocumentNumberAndCommission = (data) => {
    loadDataTemplate(data)
  }

  const resetFormFields = () => {
    form.setFieldsValue({ BENEFBANKCODE: '' })
    form.setFieldsValue({ BENEFBANKNAME: '' })
    form.setFieldsValue({ BENEFBANKADDR: '' })
    setPrefix('')
    setOptionValue(1)
  }

  const onKeyUpSwiftCode = (e) => {
    const value = e.target.value
    const number = /[0-9]+$/i
    if (optionValue == 3) {
      if (number.test(value)) {
        setFormFields((old_data) => ({
          ...old_data,
          BENEFBANKCODE: value,
        }))
      } else {
        setFormFields((old_data) => ({
          ...old_data,
          BENEFBANKCODE: value.substring(0, value.length - 1),
        }))
      }
    }
  }

  const changeAccount = (e) => {
    let value = e?.target?.value

    if (value?.length > 0 && form.getFieldValue('AMOUNT') !== '')
      setTimeout(() => {
        calculateCommission({ target: { value: form.getFieldValue('AMOUNT') } })
      }, 100)
  }

  const intermediaryBankChange = () => {
    if (showHideIntermediaryBank) {
      setFormFields((old_data) => ({
        ...old_data,
        INTERMEDBANKCODE: '',
        INTERMEDBANKNAME: '',
        INTERMEDBANKADDR: '',
      }))
      form.setFieldsValue({ INTERMEDBANKCODE: '' })
      form.setFieldsValue({ INTERMEDBANKNAME: '' })
      form.setFieldsValue({ INTERMEDBANKADDR: '' })

      setToBranchIntermed(undefined)
      updateParentComponentFormData()
    }
    setShowHideIntermediaryBank(!showHideIntermediaryBank)
  }

  const removeFile = (index: any) => {
    const myNewFiles = [...fileList]
    myNewFiles.splice(index, 1)
    setFileList(myNewFiles)
  }

  const handleSaved = () => {
    console.log(savedDocuments)
  }
  useEffect(() => {
    handleSaved()
  }, [])
 const paymentOptions = [
  {
    label: t("dgk.prepayment_goods"),
    value: "PREPAY_GOODS",
  },
  {
    label: t("dgk.prepayment_service"),
    value: "PREPAY_SERVICE",
  },
  {
    label: t("dgk.postpayment_goods"),
    value: "POSTPAY_GOODS",
  },
  {
    label: t("dgk.postpayment_service"),
    value: "POSTPAY_SERVICE",
  },
  {
    label: t("dgk.other"),
    value: "OTHER",
  },
];
  const selectCondition = (e: any) => {
  if (!e) return;

  setPaymentConditionValue(e);
  form.setFieldValue("paymentCondition", e);

  // close modal and fully reset DGK data
  setOpenDgkModal(false);
  dispatch(setDgkData(null));
  setDgkModalKey((prev) => prev + 1);

  switch (e) {
    case "PREPAY_GOODS":
      setActiveCondition("Avans");
      break;
    case "POSTPAY_GOODS":
      setActiveCondition("YGB");
      break;
    case "POSTPAY_SERVICE":
      setActiveCondition("AKT");
      break;
    case "PREPAY_SERVICE":
    case "OTHER":
    default:
      setActiveCondition("");
      break;
  }
};

  return (
    <>
      <div className="text-container" style={{
        marginLeft:"65px"
      }}>
        {' '}
        <p style={{ color: '#7B61FF' }}>
          {' '}
          <p style={{ fontWeight: '550', fontSize: 17 }}>
            {' '}
            {t('transfers.attentionCustomer')}{' '}
          </p>{' '}
          <ul>
            <li>{t('transfers.customerAttentionTextFirst')}</li>
            <li>{t('transfers.customerAttentionTextSecond')}</li>
            <li>{t('transfers.customerAttentionTextThird')}</li>
            <li>{t('transfers.customerAttentionTextFourth')}</li>
          </ul>{' '}
        </p>
      </div>
      <Row>
        <Col flex={'710px'} className="own-account">
          <Card bordered={false}>
            <Row justify="start" className="own-account__form">
              <Form
                labelCol={{ flex: '190px' }}
                wrapperCol={{ flex: 1 }}
                className="full"
                onSubmit={(e) => e.preventDefault(e)}
                onFinish={submitHandler}
                id={'form'}
                form={form}
                autoComplete="off"
                onValuesChange={updateParentComponentFormData}
                scrollToFirstError={{
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                }}
              >
                {!addOrEditPage && (
                  <div className="flex ">
                    <InputField
                      labelItem={t('salary.documentNo')}
                      placeholder={t('salary.automatically')}
                      name={'PMTCUSTID'}
                      required={true}
                      form={form}
                      value={documentNumber}
                      message={true}
                      maxLength={25}
                      allowLatinNumber={true}
                    />

                    <Button
                      size={'large'}
                      icon={<SaveIco />}
                      className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                      onClick={(e) => setTemplatePopupVisible(true)}
                    >
                      {OWNACCOUNT.PATTERN}
                    </Button>
                  </div>
                )}

                <SelectField
                  labelItem={t('transfers.fromAccount')}
                  placeholder={t('accountStatement.chooseAccount')}
                  options={fromSelectOptions}
                  name={'CUSTACC'}
                  onChange={getSelectedFromBranch}
                  required={true}
                  form={form}
                  account={true}
                  notFoundContent={
                    !loadingAccount
                      ? t('newTransfer.noAccountCorrespondingCurrency')
                      : undefined
                  }
                  defaultValue={
                    ibanNumber.ccy_name?.toString()?.toLowerCase() !== 'azn' &&
                    ibanNumber.ccy_name?.toString()?.toLowerCase() !== 'rub' &&
                    ibanNumber.iban
                      ? ibanNumber.ccy_name?.toString()?.toLowerCase() !==
                          'azn' &&
                        ibanNumber.ccy_name?.toString()?.toLowerCase() !==
                          'rub' &&
                        ibanNumber.iban
                      : undefined
                  }
                />

                <Divider
                  plain
                  orientation="left"
                  className={'tab_divider_left'}
                >
                  Alan
                </Divider>

                <InputField
                  labelItem={t('requisites.name')}
                  placeholder={t('newTransfer.nameBeneficiary')}
                  required={true}
                  name={'BENEFNAME'}
                  maxLength={70}
                  showCount={true}
                  // onlyLetter={true}
                  allowLatinNumber={true}
                  form={form}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  className={'isDisabled'}
                />

                <InputField
                  labelItem={t('deposit.accountNumber')}
                  placeholder=""
                  className="is_upper_case isDisabled"
                  name={'BENEFACC'}
                  required={true}
                  dontAllowminus={true}
                  allowLatinNumber={true}
                  maxLength={35}
                  form={form}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  onBlur={changeAccount}
                  upper={true}
                  account={true}
                />

                <InputField
                  labelItem={t('transfers.address')}
                  placeholder={t('newTransfer.enterBenefciaryFullName')}
                  required={true}
                  name={'BENEFADDR'}
                  maxLength={70}
                  showCount={true}
                  allowLatinNumber={true}
                  form={form}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  className={'isDisabled'}
                />
                  <div className="text-container" style={{marginLeft:"65px",marginBottom:"20px" }}>
                  {' '}
                  <p style={{ color: '#7B61FF',textAlign:"start"}}>
                    {' '}
                    <p>{t('transfers.attentionForCustomer')}</p>
                  </p>
                </div>
                <Divider
                  plain
                  orientation="left"
                  className={'tab_divider_left'}
                >
                  {t('newTransfer.beneficiaryBank')}
                </Divider>

                <div className={'flex'}>
                  <Col flex={'190px'}>&nbsp;</Col>

                  <Radio.Group
                    className={'receiver_bank_options'}
                    options={options}
                    value={optionValue}
                    onChange={(e) => {
                      resetFormFields()
                      onOptionsChange(e)
                    }}
                    disabled={!fromBranch?.ACCOUNT_NO}
                  />
                  <InputField
                    name={'BICINPUTTYPE'}
                    form={form}
                    className={'noneDisplay'}
                  />
                </div>

                <div className="flex flex_wrap alan_input_box">
                  <InputField
                    labelItem={selectedOptionRow?.title}
                    placeholder={selectedOptionRow?.placeholder}
                    required={selectedOptionRow?.required.titleRequired}
                    showCount={selectedOptionRow?.required.titleShowCount}
                    maxLength={selectedOptionRow?.required.titleMaxLength}
                    className={
                      'not_show_required_props isReadOnly ant-input-border'
                    }
                    name={'BENEFBANKCODE'}
                    form={form}
                    value={formFields?.BENEFBANKCODE}
                    readOnly={!fromBranch?.ACCOUNT_NO}
                    onKeyUp={(e: any) => {
                      selectedOptionRow?.autoComplete
                        ? updateBicCodes(false)
                        : false
                    }}
                    autoComplete={selectedOptionRow?.autoComplete}
                    options={bicCodes}
                    filterRowClick={updateToBicCodeAndName}
                    prefix={prefix}
                    notValid={optionValue === 1 && !bankCodeSet}
                    onlyNumber={optionValue === 2}
                    onlyNumberAndEng={optionValue === 4 || optionValue === 3}
                    startLetterOnly={optionValue === 3}
                    upper={true}
                  />

                  {optionValue == 1 && (
                    <>
                      <Col flex="40px" style={{ marginLeft: 10 }}>
                        <Button
                          size={'large'}
                          icon={<SearchIco />}
                          className="blue-button transfer__button flex align_center justify_center search_btn"
                          onClick={() => {
                            updateBicCodes(true)
                          }}
                          disabled={!fromBranch?.ACCOUNT_NO}
                        ></Button>
                      </Col>

                      <Modal
                        title={t('newTransfer.swiftCodes')}
                        closeIcon={<ModalCloseIco />}
                        centered
                        visible={swiftModalVisible}
                        onOk={() => setSwiftModalVisible(false)}
                        onCancel={() => setSwiftModalVisible(false)}
                        width={920}
                        className={
                          'manage_faster_menus swift_modal swift_modal_responsive table_scroll_modal'
                        }
                        keyboard={false}
                        focusTriggerAfterClose={false}
                        footer={false}
                      >
                        <Form
                          layout="vertical"
                          onFinish={(e) => {}}
                          autoComplete="off"
                        >
                          <table className={'table table-hover swift_table'}>
                            <thead>
                              <tr>
                                <th>
                                  <InputField
                                    modal={true}
                                    labelItem={t('transfers.swiftCode')}
                                    placeholder={t('transfers.atLeast3Char')}
                                    className={
                                      'hide_placeholder_on_focus input-border-modal'
                                    }
                                    name={'SWIFTCODE_FILTER'}
                                    form={form}
                                    onKeyUp={(e: any) => {
                                      updateBicCodes(true)
                                    }}
                                    suffix={
                                      <Button
                                        type={'ghost'}
                                        className={'transparent'}
                                        icon={<InputSearchIco />}
                                      />
                                    }
                                  />
                                </th>

                                <th>
                                  <InputField
                                    modal={true}
                                    labelItem={t('newTransfer.branchCode')}
                                    placeholder={t('transfers.atLeast3Char')}
                                    className={
                                      'hide_placeholder_on_focus input-border-modal'
                                    }
                                    name={'BENEFBANKCODE_FILTER'}
                                    form={form}
                                    onKeyUp={(e: any) => {
                                      updateBicCodes(true)
                                    }}
                                    suffix={
                                      <Button
                                        type={'ghost'}
                                        className={'transparent'}
                                        icon={<InputSearchIco />}
                                      />
                                    }
                                  />
                                </th>

                                <th>
                                  <InputField
                                    modal={true}
                                    labelItem={t('requisites.name')}
                                    placeholder={t('transfers.atLeast3Char')}
                                    className={
                                      'hide_placeholder_on_focus input-border-modal'
                                    }
                                    name={'BENEFBANKNAME_FILTER'}
                                    allowLatin={true}
                                    form={form}
                                    onKeyUp={(e: any) => {
                                      updateBicCodes(true)
                                    }}
                                    suffix={
                                      <Button
                                        type={'ghost'}
                                        className={'transparent'}
                                        icon={<InputSearchIco />}
                                      />
                                    }
                                  />
                                </th>

                                <th>
                                  <InputField
                                    modal={true}
                                    labelItem={t('transfers.address')}
                                    placeholder={t('transfers.atLeast3Char')}
                                    className={
                                      'hide_placeholder_on_focus input-border-modal'
                                    }
                                    name={'BENEFBANKADDR_FILTER'}
                                    allowLatin={true}
                                    form={form}
                                    onKeyUp={(e: any) => {
                                      updateBicCodes(true)
                                    }}
                                    suffix={
                                      <Button
                                        type={'ghost'}
                                        className={'transparent'}
                                        icon={<InputSearchIco />}
                                      />
                                    }
                                  />
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {bicCodes?.map((row) => {
                                return (
                                  <tr
                                    onClick={() => {
                                      updateToBicCodeAndName(row)
                                    }}
                                  >
                                    <td>{row.BIC_CODE}</td>
                                    <td>
                                      {row.BIC_CODE.replace(row.MAIN_BIC, '')}
                                    </td>
                                    <td>{row.BANK_NAME}</td>
                                    <td>{row.COUNTRY}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </Form>
                      </Modal>
                    </>
                  )}
                </div>

                <InputField
                  labelItem={t('requisites.name')}
                  placeholder=""
                  required={selectedOptionRow?.required.nameRequired}
                  disabled={selectedOptionRow?.required.nameDisabled}
                  readOnly={selectedOptionRow?.required.nameDisabled}
                  showCount={selectedOptionRow?.required.nameShowCount}
                  maxLength={selectedOptionRow?.required.nameMaxLength}
                  className={'isDisabled'}
                  name={'BENEFBANKNAME'}
                  allowLatinNumber={optionValue === 2 || optionValue === 3}
                  allowAllSymboll={
                    optionValue !== 2 && optionValue !== 3 && optionValue !== 4
                  }
                  onlyNumberAndUpEng={optionValue === 4}
                  form={form}
                  value={formFields?.BENEFBANKNAME}
                />

                <InputField
                  labelItem={t('transfers.address')}
                  placeholder=""
                  required={false}
                  disabled={selectedOptionRow?.required.adrDisabled}
                  readOnly={selectedOptionRow?.required.adrDisabled}
                  showCount={selectedOptionRow?.required.adrShowCount}
                  maxLength={selectedOptionRow?.required.adrMaxLength}
                  className="not-required isDisabled"
                  name={'BENEFBANKADDR'}
                  allowLatinNumber={optionValue === 2 || optionValue === 3}
                  allowAllSymboll={
                    optionValue !== 2 && optionValue !== 3 && optionValue !== 4
                  }
                  onlyNumberAndUpEng={optionValue === 4}
                  form={form}
                  value={formFields?.BENEFBANKADDR}
                />

                <div
                  className={'flex'}
                  style={{ marginBottom: !showHideIntermediaryBank ? 15 : 0 }}
                >
                  <Col flex={'190px'}>&nbsp;</Col>
                  <Checkbox
                    disabled={!fromBranch?.ACCOUNT_NO}
                    checked={showHideIntermediaryBank}
                    onChange={(e) => {
                      intermediaryBankChange()
                    }}
                  >
                    {t('newTransfer.thereIsIntermediaryBank')}
                  </Checkbox>
                </div>
                {showHideIntermediaryBank && (
                  <>
                    <Divider
                      plain
                      orientation="left"
                      className={'tab_divider_left'}
                    >
                      {t('transfers.intermediaryBank')}
                    </Divider>

                    <div className="flex">
                      <InputField
                        labelItem={t('transfers.swiftCode')}
                        placeholder=""
                        allowClear={true}
                        className="not_show_required_props ant-input-border"
                        name={'INTERMEDBANKCODE'}
                        // required={true}
                        form={form}
                        value={formFields?.INTERMEDBANKCODE}
                        onKeyUp={() => {
                          updateBankCodes(false)
                        }}
                        autoComplete={true}
                        options={bankCodes}
                        filterRowClick={updateToBankCodeAndName}
                        notValid={toBranchIntermed === undefined}
                      />
                      <Col flex="40px" style={{ marginLeft: 10 }}>
                        <Button
                          size={'large'}
                          icon={<SearchIco />}
                          className="blue-button transfer__button flex align_center justify_center search_btn"
                          onClick={() => {
                            updateBankCodes(true)
                          }}
                          disabled={!fromBranch?.ACCOUNT_NO}
                        ></Button>
                      </Col>

                      <Modal
                        title={t('newTransfer.swiftCodes')}
                        closeIcon={<ModalCloseIco />}
                        centered
                        visible={codeModalVisible}
                        onOk={() => setCodeModalVisible(false)}
                        onCancel={() => setCodeModalVisible(false)}
                        width={920}
                        className={
                          'manage_faster_menus swift_modal swift_modal_responsive table_scroll_modal'
                        }
                        keyboard={false}
                        focusTriggerAfterClose={false}
                        footer={false}
                      >
                        <Form
                          layout="vertical"
                          onFinish={(e) => {}}
                          autoComplete="off"
                        >
                          <table className={'table table-hover swift_table '}>
                            <thead>
                              <tr>
                                <th>
                                  <InputField
                                    modal={true}
                                    labelItem={t('transfers.swiftCode')}
                                    placeholder={t('transfers.atLeast3Char')}
                                    className={
                                      'hide_placeholder_on_focus input-border-modal'
                                    }
                                    name={'INTERMEDBANKCODE'}
                                    form={form}
                                    suffix={
                                      <Button
                                        onClick={() => {
                                          updateBankCodes(true)
                                        }}
                                        type={'ghost'}
                                        className={'transparent'}
                                        icon={<InputSearchIco />}
                                      />
                                    }
                                    onKeyUp={(e: any) => {
                                      updateBankCodes(true)
                                    }}
                                  />
                                </th>
                                <th>
                                  <InputField
                                    modal={true}
                                    labelItem={t('newTransfer.branchCode')}
                                    placeholder={t('transfers.atLeast3Char')}
                                    className={
                                      'hide_placeholder_on_focus input-border-modal'
                                    }
                                    name={'INTERMEDBANKCODE_FILTER'}
                                    form={form}
                                    onKeyUp={(e: any) => {
                                      updateBankCodes(true)
                                    }}
                                    suffix={
                                      <Button
                                        onClick={() => {
                                          updateBankCodes(true)
                                        }}
                                        type={'ghost'}
                                        className={'transparent'}
                                        icon={<InputSearchIco />}
                                      />
                                    }
                                  />
                                </th>
                                <th>
                                  <InputField
                                    modal={true}
                                    labelItem={t('requisites.name')}
                                    placeholder={t('transfers.atLeast3Char')}
                                    className={
                                      'hide_placeholder_on_focus input-border-modal'
                                    }
                                    name={'INTERMEDBANKNAME_FILTER'}
                                    allowLatin={true}
                                    form={form}
                                    onKeyUp={(e: any) => {
                                      updateBankCodes(true)
                                    }}
                                    suffix={
                                      <Button
                                        onClick={() => {
                                          updateBankCodes(true)
                                        }}
                                        type={'ghost'}
                                        className={'transparent'}
                                        icon={<InputSearchIco />}
                                      />
                                    }
                                  />
                                </th>
                                <th>
                                  <InputField
                                    modal={true}
                                    labelItem={t('transfers.address')}
                                    placeholder={t('transfers.atLeast3Char')}
                                    className={
                                      'hide_placeholder_on_focus input-border-modal'
                                    }
                                    name={'INTERMEDBANKADDR_FILTER'}
                                    allowLatin={true}
                                    form={form}
                                    onKeyUp={(e: any) => {
                                      updateBankCodes(true)
                                    }}
                                    suffix={
                                      <Button
                                        onClick={() => {
                                          updateBankCodes(true)
                                        }}
                                        type={'ghost'}
                                        className={'transparent'}
                                        icon={<InputSearchIco />}
                                      />
                                    }
                                  />
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {bankCodes?.map((row) => {
                                return (
                                  <tr
                                    onClick={() => {
                                      updateToBankCodeAndName(row)
                                    }}
                                  >
                                    <td>{row.BIC_CODE}</td>
                                    <td>
                                      {row.BIC_CODE.replace(row.MAIN_BIC, '')}
                                    </td>
                                    <td>{row.BANK_NAME}</td>
                                    <td>{row.COUNTRY}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </Form>
                      </Modal>
                    </div>

                    <InputField
                      labelItem={t('requisites.name')}
                      placeholder=""
                      className={'not-required dark-input'}
                      required={false}
                      disabled={true}
                      readOnly={true}
                      onlyLetter={true}
                      form={form}
                      name={'INTERMEDBANKNAME'}
                      value={formFields?.INTERMEDBANKNAME}
                    />

                    <InputField
                      labelItem={t('transfers.address')}
                      placeholder=""
                      required={false}
                      disabled={true}
                      readOnly={true}
                      className="not-required dark-input"
                      form={form}
                      name={'INTERMEDBANKADDR'}
                      value={formFields?.INTERMEDBANKADDR}
                    />
                  </>
                )}

                <Divider className="no_text" />

                <div className={'flex'}>
  <div
    className="amount_and_commission_col"
    style={{
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <AmountField
                    labelItem={t('common.amount')}
                    placeholder=""
                    currencyClass={ fromBranch?.CCY_NAME === "USD"?'amountCurrencydropdown': ''}
           suffix={
    fromBranch?.CCY_NAME === "USD" ? (
      <Select
        value={amountCurrency}
        onChange={(value) => setAmountCurrency(value)}
        options={currencyOptions}
        bordered={false}
        style={{ width: 90 }}
        dropdownMatchSelectWidth={false}
        getPopupContainer={(trigger) => trigger.parentElement}
        disabled={!fromBranch?.ACCOUNT_NO}
      />
    ) : (
      fromBranch?.CCY_NAME || ""
    )
  }
                    name={'AMOUNT'}
                    className={`amount_input isDisabled amntDgk`}
                    form={form}
                    disabled={!fromBranch?.ACCOUNT_NO}
                    />

    {hasDgkAmountError ? (
      <div
        style={{
          color: '#ff4d4f',
          fontSize: '12px',
          lineHeight: '20px',
          marginTop: '-10px',
          marginLeft: '190px',
          marginBottom:"12px"
        }}
      >
        {(dgkData.type === "Avans" || dgkData.type === "AVANS")? t('dgk.total_less_than_avans'):dgkData.type === "AKT"?t('dgk.total_less_than_akt'):t('dgk.total_less_than_gb')}
      </div>
    ) : null}
  </div>

  <Col className={'commission_col mobile-select dgkEditBox'}>
    <InputField
      labelCol={2}
      labelItem={t('home.commission')}
      placeholder=""
      className="dark-input commission_input commission_border isReadOnly dgkEdit"
      suffix={fromBranch?.CCY_NAME}
      form={form}
      name={'COMMAMOUNT'}
      hasLoading={commissionLoading}
      readOnly={true}
      required={true}
      message={''}
      notValid={form.getFieldValue('COMMAMOUNT') === ''}
    />
  </Col>
</div>
                <div className={'flex'}>
                  <SelectField
                    labelItem={t("dgk.payment_terms")}
                    placeholder={t("dgk.common.select")}
                    options={paymentOptions}
                    value={paymentConditionValue}
                    name={"paymentCondition"}
                    onChange={(e: any) => selectCondition(e)}
                    required={true}
                    form={form}
                    disabled={!form.getFieldValue("AMOUNT")}
                    className = "selectionFieldDgk"
                  />
                 
                  <div className="btn-space">
                    {conditions.map((c) => {
                        const isSelected = dgkData?.type === c;

                        return (
                          <div className="dgkButtonWrapper">
                            <Button
                              key={c}
                              disabled={activeCondition !== c}
                              onClick={() => setOpenDgkModal(true)}
                              className={`baseClass 
                                ${activeCondition === c ? 'mustSelect' : ''} 
                                ${isSelected ? 'dgkSelected' : ''}
                              `}
                            >
                              {c === 'YGB' ? (
                                t('dgk.ygb')
                              ) : c === 'AKT' ? (
                                t('dgk.akt')
                              ) : (
                                t('dgk.advance')
                              )}
                            </Button>
                        
                            {c === 'YGB' &&
                              dgkData?.type === 'YGB' &&
                              dgkData.pages?.length > 0 && (
                                <span className="dgkCountBadge">
                                  {dgkData.pages.length}
                                </span>
                              )}
                        
                            {c === 'AKT' &&
                              dgkData?.type === 'AKT' &&
                              dgkData.pages?.length > 0 && (
                                <span className="dgkCountBadge">
                                  {dgkData.pages.length}
                                </span>
                              )}
                        
                            {c === 'Avans' &&
                              dgkData?.type === 'Avans' &&
                              dgkData.contracts?.length > 0 && (
                                <span className="dgkCountBadge">
                                  {dgkData.contracts.length}
                                </span>
                              )}
                          </div>
                        );
                      })}
                  </div>  
                </div>
                {currAmount && infoData && openCrossMessage ? (<div className={'flex'}>
                  <FormItem label={" "}>
                    <div
                    style={{
                      backgroundColor: "#E4F1FF",
                      padding: "8px 12px",
                      borderRadius: "12px",
                      fontWeight: 500,
                      color:"#5895E2",
                      border:"1px solid #9EC3F0",
                      width:"100%",
                      maxWidth:700
                    }}
                  >
                        {currAmount} {infoData?.pmtCurr} = {infoData?.exchAmount}{" "}
                        {infoData?.accCurr} &nbsp;
                        (1 {infoData?.accCurr} = {infoData?.rate} {infoData?.pmtCurr}) <br />
                        {t('transfers.swiftCrossMessage')}
                  </div>
                  </FormItem>
                </div>):null}
                <FormItem
                  required={!form.getFieldValue('BENEFACC')?.startsWith('AZ')}
                  label={t('salary.documents')}
                >
                  <div className="flex items-center justify-between valyuta-footer">
                    <div
                      className="documentsIco"
                      style={{
                        display: 'flex',
                        height: 50,
                        alignItems: 'center',
                      }}
                    >
                      <InputField
                        form={form}
                        name={'transferDocs'}
                        placeholder=""
                        style={{ width: 0, height: 0, position: 'fixed' }}
                        readOnly={true}
                        required={false}
                      />

                      <Button
                        size={'large'}
                        icon={<DocumentsIco className="" />}
                        disabled={!fromBranch}
                        className={`${
                          (documentsCount === 0 ||
                            documentsCount === null ||
                            documentsCount === undefined) &&
                          !form.getFieldValue('BENEFACC')?.startsWith('AZ') &&
                          fromBranch
                            ? 'warning-button'
                            : !fromBranch
                            ? 'disable-button'
                            : 'light-button'
                        } refresh_btn btn flex align_center justify_center`}
                        onClick={(e) => {
                          setDocumentsModalVisible(true)
                        }}
                      >
                        {t(OWNACCOUNT.DOCUMENTS) + ' ('}
                        <span className="count">
                          {documentsCount === 0 ||
                          documentsCount === null ||
                          documentsCount === undefined
                            ? '0'
                            : documentsCount}
                        </span>
                        {')'}
                      </Button>
                    </div>
                    <div style={{ alignContent: 'center' }}>
                      <p className="textFC">{t('transfers.documentInform')}</p>
                    </div>
                  </div>
                </FormItem>

                <TextAreaField
                  visible={true}
                  labelItem={t('accountStatement.paymentDetails')}
                  placeholder={t('notification.detailPlaceholder')}
                  showCount={true}
                  maxLength={'350'}
                  required={true}
                  name={'PMTDET'}
                  form={form}
                  // value={
                  //   savedDocuments !== '' && documentsCount !== 0
                  //     ? savedDocuments?.length > 350
                  //       ? savedDocuments.substring(0, 350)
                  //       : savedDocuments
                  //     : ''
                  // }
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  allowDestination={true}
                  className={'isDisabled'}
                />

          

                <div className={'flex'}>
                  <Col flex={1}>
                    <TextAreaField
                      visible={visible}
                      className="not-required plus_minus_area isDisabled"
                      labelItem={t('newTransfer.note')}
                      placeholder={t('newTransfer.notTransferableToBank')}
                      showCount={true}
                      maxLength={'180'}
                      name={'NOTE'}
                      readOnly={!fromBranch?.ACCOUNT_NO}
                      form={form}
                      // allowAllSymboll={true}
                      allowDestination={true}
                    />
                  </Col>
                  <Button
                    className="icon-button add-remove-btn"
                    icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                    onClick={() => setVisible(!visible)}
                  />
                </div>

                <FileUpload
                  className="file-upload isDisabled"
                  labelItem={t('newTransfer.attachPDF')}
                  accept="application/pdf"
                  multiple={false}
                  required={false}
                  form={form}
                  name={'pdf_files'}
                  onChange={getFileList}
                  fileLimit={10}
                  checkSize={true}
                  disabled={!fromBranch?.ACCOUNT_NO}
                  editFileList={fileList}
                  ibankRef={ibankRef}
                  editOrRepeat={editOrRepeat}
                  removeFile={removeFile}
                />

                {!addOrEditPage && (
                  <div className="flex button_row">
                    <Button
                      size={'large'}
                      icon={<SaveBlueIco />}
                      className="light-button btn save_btn flex align_center justify_center"
                      htmlType={'button'}
                      onClick={openSaveAsTemplateModal}
                    >
                      {OWNACCOUNT.SAVE}
                    </Button>

                    <div className={'flex flex_wrap valyuta-footer'}>
                      <Button
                        size={'large'}
                        icon={<RefreshIco />}
                        className="light-button refresh_btn btn flex align_center justify_center"
                        onClick={(e) => {
                          onCloseSuccessModal()
                          saveDocumentsModal(dataDocumentModal)
                        }}
                      >
                        {t(OWNACCOUNT.REFRESH)}
                      </Button>

                      <Button
                        size={'large'}
                        disabled={
                            (
                              (documentsCount === 0 ||
                                documentsCount === null ||
                                documentsCount === undefined) &&
                              !form.getFieldValue('BENEFACC')?.startsWith('AZ')
                            ) ||
                            !isDgkCompleted() ||
                            hasDgkAmountError
                          }
                        htmlType="submit"
                        className="blue-button next_btn btn flex align_center justify_center"
                      >
                        {OWNACCOUNT.NEXT}
                      </Button>
                    </div>
                  </div>
                )}
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>

      <DocumentsModal
        visible={documentsModalVisible}
        title={t('modal.modalTitleDocs')}
        children={<h1>documents modal</h1>}
        onCancel={(e, savedDocuments, createDocument) => {
          cancelPMTDETRef.current = form.getFieldValue("PMTDET")
          setcreateData(createDocument)
          setSaveDocuments(savedDocuments)
          setDocumentsCount(e)
          setDocumentsModalVisible(false)
          form.setFieldsValue({
            transferDocs: createDocument,
          })
          updateParentComponentFormData()
        }}
        dataModal={documentsModalData}
        onDisabled={() => setDocumentsCount(0)}
        refreshData={refreshDocuments}
        className="documents_modal"
        onSuccessClose={(bool, e, savedDocuments, createDocument) => {
          setDocumentsModalVisible(bool)
          if (savedDocuments?.length > 0) {
            form.setFieldsValue({
              PMTDET:
                savedDocuments !== '' && e !== 0
                  ? savedDocuments?.length > 350
                    ? savedDocuments.substring(0, 350)
                    : savedDocuments
                  : '',
            })
          }
          
        }}
        saveDocumentsModal={(savedDocuments: any) => {
          saveDocumentsModal(savedDocuments)
        }}
      />

      <NextModal
        errorIcon={<EroorIco />}
        callBackApi={newTransferFunc}
        visible={nextModalVisible}
        currencyModalData={createData}
        onClose={() => {
          setNextModalVisible(false)
          setRetryRequest(null)
        }}
        onCloseSuccessModal={() => {
          onCloseSuccessModal()
        }}
        data={modalData}
        className={'no_footer_line'}
        nextModalTitle={t('home.transfer')}
        nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
        currentForm={form}
        transfer={true}
        repeatPdfList={fileList}
        infoForCurrency = {infoData?infoData:null}
        currAmount = {currAmount}
        tableData={tableData}
        editTransfer={
          ibankRef !== undefined && ibankRef !== '' && ibankRef !== null
        }
      />

      <TemplatePopup
        visible={templatePopupVisible}
        onClose={setTemplatePopupVisible}
        trnType={'SWIFT'}
        currentForm={form}
        updateAfterTemplate={updateDocumentNumberAndCommission}
      />
      <DgkModal
        key={`${activeCondition}-${dgkModalKey}`}
        visible={openDgkModal}
        setVisible={setOpenDgkModal}
        transferKind={activeCondition}
        iban={fromBranch?.IBAN}
        transferAmount={
          openCrossMessage && !isNaN(Number(infoData?.exchAmount))
            ? Number(infoData.exchAmount)
            : (!isNaN(Number(transferAmount)) ? Number(transferAmount) : 0)
        }
        toConvert={toConvert}
        // When the account is USD the amount currency is a free choice, so a
        // foreign pick (NOK/JPY/...) has to reach the DGK currency dropdowns too.
        transferCurrency={fromBranch?.CCY_NAME === 'USD' ? amountCurrency : undefined}
        beneficiaryName={form.getFieldValue("BENEFNAME")}
        onPersistDgkData={(nextData: any) => dispatch(setDgkData(nextData))}
      />
      <SaveAsTemplate
        visible={saveAsTemplatePopupVisible}
        onClose={setSaveAsTemplatePopupVisible}
        trnType={'SWIFT'}
        transferDocs={documentsData}
        currentForm={form}
        amountCurr = {amountCurrency}
      />
      {loadingData ? <FullScreenLoading /> : <></>}
    </>
  )
}

const mapDispatchToProps = { setIbanNumber }

const mapStateToProps = (state: any, ownProps: any) => ({
  ownProps: ownProps,
  ibanNumber:
    state.accountsStatement && state.accountsStatement.ibanNumber
      ? state.accountsStatement.ibanNumber
      : {},
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrencyTransactions)
